const translations = {
  "en": {
    "language": "English",
    "getStarted": "Get Started",
    "hello": "Hello {name}",
    "onboardingPageOneTitle": "Welcome to Crew Core",
    "onboardingPageTwoTitle": "Your journey starts here",
    "onboardingPageThreeTitle": "Let's get started!",
    "onboardingBottomSheetTitle": "Easy way to confirm\nyour attendance",
    "onboardingBottomSheetSubtitle": "It is a long established fact a reader\nwill be distracted by the readable content.",
    "next": "Next",
    "needHelp": "Need Help",
    "welcomeBack": "Welcome Back!",
    "to": "To",
    "loginPageSubtitle": "Hello there, Login to continue",
    "email": "E-Mail",
    "emailHint": "Enter your email",
    "password": "Password",
    "passwordHint": "Enter your password",
    "forgotPassword": "Forgot Password?",
    "doNotHaveAnAccount": "Don't have an account? ",
    "haveAnAccount": "Already have an account? ",
    "register": "Register",
    "orContinueWith": "OR Continue with",
    "login": "Login",
    "firstName": "First Name",
    "firstNameHint": "Enter first name",
    "lastName": "Last Name",
    "lastNameHint": "Enter last name",
    "confirmPassword": "Confirm Password",
    "confirmPasswordHint": "Re-enter your password",
    "iAgreeToThe": "I agree to the ",
    "termsAndConditions": "Terms and Conditions",
    "requiredField": "This field is required.",
    "invalidEmail": "Please enter a valid email address.",
    "passwordTooShort": "Password must be at least 6 characters.",
    "passwordsDoNotMatch": "Passwords do not match",
    "acceptTermsMessage": "You must accept the Terms and Conditions to continue.",
    "forgot_password": "Forgot Password",
    "provide_mail": "Just provide us with your mail",
    "doNot_worry": "Don't worry",
    "send_email": "Send Email",
    "termsAndConditionsText": "Welcome to our application. By accessing or using this app, you agree to be bound by the following Terms and Conditions.\n\n1. Acceptance of Terms\nBy creating an account or using our services, you agree to these Terms and our Privacy Policy.\n\n2. User Responsibilities\n- You must be at least 13 years old to use the app.\n- You are responsible for maintaining the confidentiality of your account.\n- You must provide accurate, current, and complete information.\n\n3. Usage Restrictions\nYou agree not to:\n- Use the app for any illegal or unauthorized purpose.\n- Interfere with the app’s operation.\n- Attempt to gain unauthorized access.\n\n4. Intellectual Property\nAll content and data are the intellectual property of the app owner and may not be used without permission.\n\n5. Termination\nWe may suspend or terminate your access without notice if you violate these terms.\n\n6. Disclaimer\nThis app is provided “as is” without warranties of any kind.\n\n7. Changes to Terms\nWe may update these Terms at any time. Continued use means you accept the changes.\n\n8. Contact Us\nIf you have questions, contact support@example.com",
    "noInternetMessage": "No internet connection. Please check your connection.",
    "unknownError": "An unknown error occurred. Please try again later.",
    "invalidEmailOrPassword": "Invalid email or password",
    "wrongPassword": "Invalid email or password. Please check your password.",
    "userNotFound": "User not found. Please check your credentials.",
    "companyNotFound": "Company not found. Please check the company name.",
    "invalidToken": "Invalid session token. Please log in again.",
    "genericLoginError": "An error occurred. Please try again later.",
    "congratulations": "Congratulations",
    "yourAccountIsReadyToUse": "Your account is ready to use!",
    "resetEmailSent": "Reset email sent successfully.",
    "enableBiometrics": "Enable biometric login?",
    "enableBiometricsDescription": "Would you like to log in faster using your fingerprint or face next time?",
    "loginWithBiometrics": "Login with biometrics",
    "yes": "Yes",
    "no": "No",
    "biometricsNotFound": "Biometrics are not found! please sign in again",
    "resetPasswordTitle": "Reset Password?",
    "resetPasswordWarning": "If you reset your password, your biometric login will be disabled. You’ll need to sign in again and re-enable it.",
    "cancel": "Cancel",
    "continueText": "Continue",
    "googleSignInFailed": "Google sign-in was canceled or failed",
    "myWorkSummary": "My Work Summary",
    "myWorkSummarySubtitle": "Today task & presence activity",
    "todaysAttendance": "Today's Attendance",
    "totalWorkingHours": "Total Working Hours",
    "today": "Today",
    "breaksToday": "Breaks Today",
    "clockIn": "Clock In",
    "backToWork": "Back to Work",
    "takeABreak": "Take a Break",
    "clockOut": "Clock Out",
    "hoursLabel": "{hours}:{minutes} Hrs",
    "paidPeriod": "Paid Period {start} - {end}",
    "period": "Period {start} - {end}",
    "clockInAreaTitle": "You are in the clock‑in area!",
    "clockInAreaDescription": "Now you can press clock in in this area",
    "notInClockInAreaTitle": "You are out of the clock‑in area!",
    "notInClockOutAreaTitle": "You are out of the clock‑out area!",
    "notInClockInAreaDescription": "you can not clock from this area",
    "myProfileSection": "MY PROFILE",
    "scheduleSection": "SCHEDULE",
    "clockInAreaLabel": "Clock In/Out Area",
    "fetchingLocation": "Fetching location…",
    "error": "Error",
    "yourActivity": "Your Activity",
    "activity": "Activity",
    "onTime": "On Time",
    "viewAll": "View All",
    "confirmClockOutTitle": "Confirm Clockout",
    "confirmClockOutMessage": "Once you clock out, you won’t be able to edit this time. Please double-check your hours before proceeding.",
    "noLetMeCheck": "No, Let me check",
    "thisPayPeriod": "Paid Period",
    "locationUnavailable": "Location unavailable",
    "locationUnavailableMessage": "Your location is not available. Please check your device location settings and try again.",
    "noInternetActionSaved": "No internet connection. Your clock‑in/out has been saved locally and will sync once you’re back online.",
    "manager": "Manager",
    "client": "Client",
    "tasks": "Tasks",
    "projects": "Projects",
    "projectsSubtitle": "The projects you are assigned to",
    "tasksSubtitle": "The tasks assigned to you",
    "homeTitle": "Home",
    "homeWelcomeMessage": "Welcome, {userName}! You are logged in.",
    "loggedInAs": "Logged in as:",
    "companyName": "Company:",
    "logout": "Logout",
    "attendance": "Attendance",
    "more": "More",
    "pleaseWaitOneMinute": "Please wait at least 1 minute between actions.",
    "leaveSummary": "Leave Summary",
    "available": "Available",
    "leaveUsed": "Leave Used",
    "review": "Review",
    "approved": "Approved",
    "rejected": "Rejected",
    "leaveSubmitted": "Leave Submitted",
    "leaveInformation": "Leave Information",
    "expensesSubmitted": "Expenses Submitted",
    "expensesInformation": "Expenses Information",
    "approvalSubmitted": "Approval Submitted",
    "approvalInformation": "Approval Information",
    "leaveDate": "Leave Date",
    "approvedAt": "Approved At",
    "rejectedAt": "Rejected At",
    "expenseSummary": "Expense Summary",
    "claimYourExpensesHere": "Claim Your Expenses Here.",
    "totalLeave": "Total Leave",
    "totalExpense": "Total Expense",
    "total": "Total",
    "type": "Type",
    "allApprovals": "All Approvals",
    "totalApprovals": "Total Approvals",
    "noLeaveSubmitted": "No Leave Submitted!",
    "noLeaveApproved": "No Leave Approved!",
    "noLeaveRejected": "No Leave Rejected!",
    "noLeaveSubmittedSubtitle": "Ready to catch some fresh air? Click “Submit Leave” and take that well-deserved break!",
    "noExpenseSubmitted": "No Expense Submitted!",
    "noExpenseApproved": "No Expense Approved!",
    "noExpenseRejected": "No Expense Rejected!",
    "noExpenseSubtitle": "It looks like you don’t have any expenses here. Don’t worry, this space will be updated as new expense data comes.",
    "noApprovalSubmitted": "No Approval Submitted!",
    "noApprovalApproved": "No Approval Approved!",
    "noApprovalRejected": "No Approval Rejected!",
    "noApprovalSubtitle": "It looks like you don’t have any approvals here. Don’t worry, this space will be updated as new Approval data comes.",
    "pleaseSelectLeaveCategory": "Please select a leave category",
    "pleaseSelectLeaveDuration": "Please select leave duration",
    "pleaseSelectTaskDelegation": "Please select task delegation",
    "submitLeave": "Submit Leave",
    "submitLeaveMessage": "Double-check your leave details to ensure everything is correct. Do you want to proceed?",
    "submitMessage": "Double-check your details to ensure everything is correct. Do you want to proceed?",
    "submitText": "Yes, Submit",
    "fillLeaveInformation": "Fill Leave Information",
    "informationAboutLeaveDetails": "Information about leave details",
    "leaveCategory": "Leave Category",
    "selectLeaveCategory": "Select Leave Category",
    "leaveDuration": "Leave Duration",
    "selectDuration": "Select Duration",
    "taskDelegation": "Task Delegation",
    "selectTaskDelegation": "Select Task Delegation",
    "emergencyContactDuringLeavePeriod": "Emergency Contact During Leave Period",
    "pleaseEnterContactNumber": "Please enter contact number",
    "numberTooShort": "Number too short",
    "leaveDescription": "Leave Description",
    "enterLeaveDescription": "Enter Leave Description",
    "pleaseEnterDescription": "Please enter description",
    "submitNow": "Submit Now",
    "selectCategory": "Select Category",
    "leaveRequest": "Leave Request",
    "expenseRequest": "Expense Request",
    "approvalRequest": "Approval Request",
    "leavesApproved": "Leaves Approved",
    "leavesRejected": "Leaves Rejected",
    "expensesApproved": "Expenses Approved",
    "expensesRejected": "Expenses Rejected",
    "approvalsApproved": "Approvals Approved",
    "approvalsRejected": "Approvals Rejected",
    "submitExpense": "Submit Expense",
    "fillClaimInformation": "Fill Claim Information",
    "informationAboutClaimDetails": "Information about claim details",
    "expenseCategory": "Expense Category",
    "selectExpenseCategory": "Select Expense Category",
    "paidBy": "Paid By",
    "selectEmployeeOrCompany": "Select Employee Or Company",
    "expenseDate": "Expense Date",
    "enterTransactionDate": "Enter Transaction Date",
    "expenseAmount": "Expense Amount",
    "expenseDescription": "Expense Description",
    "enterExpenseDescription": "Enter Expense Description",
    "uploadClaimDocument": "Upload Claim Document",
    "enterPeriod": "Enter Period",
    "submitApproval": "Submit Approval",
    "fillApprovalInformation": "Fill Approval Information",
    "informationAboutApprovalDetails": "Information About Approval Details",
    "approvalCategory": "Approval Category",
    "selectApprovalCategory": "Select Approval Category",
    "requestOwner": "Request Owner",
    "location": "Location",
    "pleaseEnterLocation": "Please Enter Location",
    "date": "Date",
    "enterDate": "Enter Date",
    "periodd": "Period",
    "reference": "Reference",
    "pleaseEnterReference": "Please Enter Reference",
    "contact": "Contact",
    "pleaseEnterContact": "Please Enter Contact",
    "uploadFile": "Upload File",
    "approvalDescription": "Approval Description",
    "enterApprovalDescription": "Enter Approval Description",
    "quantity": "Quantity",
    "enterQuantity": "Enter quantity",
    "pleaseEnterQuantity": "Please enter a valid quantity",
    "quantityMustBePositiveNumber": "Quantity must be a positive number",
    "product": "Product",
    "addProduct": "Add Product",
    "productName": "Product Name",
    "description": "Description",
    "close": "Close",
    "add": "Add",
    "requests": "Requests",
    "title": "Title",
    "pleaseEnterTitle": "Please enter a title",
    "errorLoadingCategories": "Error loading categories.",
    "noCategoriesAvailable": "No Categories Available.",
    "amount": "Amount",
    "enterAmount": "Enter Amount",
    "errorLoadingContacts": "Error Loading Contacts",
    "name": "Name",
    "enterName": "Enter name",
    "pleaseEnterName": "Please enter a name.",
    "enterValidAmount": "Please enter a valid amount.",
    "account": "Account",
    "selectAccount": "Select Account",
    "selectExpenseAccount": "Select Expense Account",
    "vendor": "Vendor",
    "selectVendor": "Select Vendor",
    "selectExpenseVendor": "Select Expense Vendor",
    "saleOrder": "Sale Order",
    "selectSaleOrder": "Select Sale Order",
    "selectExpenseSaleOrder": "Select Expense Sale Order",
    "currency": "Currency",
    "selectCurrency": "Select Currency",
    "selectExpenseCurrency": "Select Expense Currency",
    "customerToReinvoice": "Customer To Reinvoice",
    "selectCustomerToReinvoice": "Select Customer To Reinvoice",
    "pleaseEnterStartDate": "Please enter a start date.",
    "pleaseEnterEndDate": "Please enter an end date.",
    "startDate": "Start Date",
    "endDate": "End Date",
    "pleaseEnterStartTime": "Please enter a start time.",
    "pleaseEnterEndTime": "Please enter an end time.",
    "startTime": "Start Time",
    "endTime": "End Time",
    "pleaseSelectDayPart": "Please select a day part.",
    "hourBasedLeave": "Hour Based Leave",
    "halfDayLeave": "Half Day Leave",
    "selectStartTime": "Select Start Time",
    "selectEndTime": "Select End Time",
    "selectDayPart": "Select Day Part",
    "dayPart": "Day Part",
    "categoryLeaveDaysExceeded": "The total number of leave days exceeds the allowed limit for this Category.",
    "allowedDays": "Allowed Days:",
    "allowedHours": "Allowed Hours:",
    "endTimeMustBeAfterStartTime": "End time must be after start time",
    "categoryLeaveBalanceExceeded": "The requested leave exceeds your remaining balance",
    "hr": "HR",
    "employees": "Employees",
    "viewAndEditYourEmployeesData": "View And Edit Your Employees Data",
    "employeesInformation": "Employees Information",
    "noName": "No Name",
    "noEmail": "No Email",
    "noPhone": "No Phone",
    "noType": "No Type",
    "changesSavedSuccessfully": "Changes saved successfully!",
    "editModeEnabled": "Edit mode enabled",
    "confirmDelete": "Confirm Delete",
    "areYouSureYouWantToDeleteThisEmployee": "Are you sure you want to delete this employee?",
    "thisActionCannotBeUndone": "This action cannot be undone.",
    "delete": "Delete",
    "employeeDeletedSuccessfully": "Employee deleted successfully",
    "addLocation": "Add Location",
    "locationName": "Location Name",
    "address": "Address",
    "locationAddedSuccessfully": "Location added successfully",
    "employeeDetails": "Employee Details",
    "employeeInformation": "Employee Information",
    "fullName": "Full Name",
    "workEmail": "Work Email",
    "workPhone": "Work Phone",
    "employeeType": "Employee Type",
    "departmentID": "Department ID",
    "companyInformation": "Company Information",
    "company": "Company",
    "notSpecified": "Not specified",
    "categories": "Categories",
    "none": "None",
    "assignedLocations": "Assigned Locations",
    "noLocationsAssigned": "No locations assigned",
    "saveChanges": "Save Changes",
    "employeeAlreadyExists": "Employee already exists",
    "createNewEmployee": "Create New Employee",
    "employeeName": "Employee Name",
    "enterFullName": "Enter full name",
    "pleaseEnterEmployeeName": "Please enter employee name",
    "enterWorkEmail": "Enter work email",
    "pleaseEnterEmailAddress": "Please enter email address",
    "pleaseEnterAValidEmail": "Please enter a valid email",
    "createEmployee": "Create Employee",
    "byCreatingThisProfileYouAgreeToOurTermsOfService": "By creating this profile, you agree to our Terms of Service",
    "employeeCreatedSuccessfully": "Employee Created Successfully!",
    "hasBeenAddedToYourTeam": "has been added to your team",
    "backToEmployees": "Back to Employees",
    "pleaseEnter": "Please enter",
    "addNewTeamMember": "Add New Team Member",
    "fillInTheDetailsToCreateANewEmployeeProfile": "Fill in the details to create a new employee profile",
    "deadline": "Deadline",
    "progress": "Progress",
    "status": "Status",
    "assignees": "Assignees",
    "timesheets": "Timesheets",
    "taskId": "Task ID",
    "project": "Project",
    "task": "Task",
    "selectTask": "Select Task",
    "allProjects": "All Projects",
    "allTasks": "All Tasks",
    "addTimesheet": "Add Timesheet",
    "quickAdd": "Quick Add",
    "loading": "Loading...",
    "timesheetAddedSuccessfully": "Timesheet added successfully",
    "noTimesheetRecordsYet": "No timesheet records yet",
    "enterDescription": "Enter Description",
    "timesheetDeletedSuccessfully": "Timesheet deleted successfully",
    "edit": "Edit",
    "editTimesheet": "Edit Timesheet",
    "currentSession": "Current Session",
    "locationDisabled": "Location Disabled",
    "enableLocationMessage": "To use location-based clock-in/out, please enable location services in your device settings.",
    "settings": "Settings",
    "microphonePermissionNotGranted": "Microphone permission not granted",
    "microphoneAccessNeeded": "Microphone Access Needed",
    "thisAppNeedsMicrophoneAccessToRecordVoiceNotesForYourTimesheets": "This app needs microphone access to record voice notes for your timesheets.",
    "deny": "Deny",
    "allow": "Allow",
    "microphonePermissionIsRequiredToRecordAudio": "Microphone permission is required to record audio",
    "failedToPlayRecording": "Failed to play recording",
    "voiceNote": "Voice Note",
    "recording": "Recording",
    "duration": "Duration",
    "stopRecording": "Stop Recording",
    "recordNow": "Record Now",
    "addExpense": "add expense",
    "submitExpenseReport": "Submit Expense Report",
    "reportInformation": "Report Information",
    "informationAboutReportDetails": "Information about Report Details",
    "reportName": "Report Name",
    "enterReportName": "Enter Report Name",
    "pleaseEnterReportName": "Please enter report name",
    "expenses": "Expenses",
    "submitReport": "Submit Report",
    "expenseReport": "Expense Report",
    "savedExpenses": "Saved Expenses",
    "expensesInProgress": "Expenses in Progress",
    "saveExpense": "Save Expense",
    "expenseSaved": "Expense Saved",
    "selectProject": "Select Project",
    "submitForReview": "Submit for Review",
    "submit": "Submit",
    "save": "Save",
    "submitToReview": "Submit to Review",
    "pleaseFillAllRequiredFields": "Please fill all required fields",
    "reportSaved": "Report Saved",
    "reportSubmitted": "Report Submitted",
    "addAtLeastOneExpense": "Add at least one expense",
    "fixExpenseErrors": "Fix Expense Errors",
    "fixExpenseErrorsBeforeSubmit": "Fix expense errors before submitting",
    "submissionFailed": "Submission Failed",
    "audioPlayback": "Audio Playback",
    "failedToLoadAudio": "Failed to load audio",
    "failedToPlayAudio": "Failed to play audio",
    "failedToStopAudio": "Failed to stop audio",
    "failedToSeekAudio": "Failed to seek audio",
    "loadingAudio": "Loading audio...",
    "retry": "Retry",
    "reportDeleted": "Report's been deleted successfully",
    "draft": "Draft",
    "reportUpdated": "Report's been updated successfully",
    "rememberMe": "Remember Me",
    "loggingInTo": "Logging in to",
    "yourLastOrganization": "your last organization",
    "clockingOutFrom": "Clocking out from",
    "clockingOut": "Clocking out",
    "clockingInFrom": "Clocking in from",
    "clockingIn": "Clocking in",
    "youCanPressClockIn": "You can press clock in",
    "youCanPressClockOut": "You can press clock out",
    "thereWasNoChangesApplied": "There were no changes applied",
    "fromTo": "From - To",
    "time": "Time",
    "by": "By",
    "requestDetails": "Request Details",
    "products": "Products",
    "approval": "Approval",
    "recordOn": "Record on",
    "category": "Category",
    "lastUpdatedOn": "Last Updated on",
    "dateSet": "Date set",
    "contactName": "Contact Name",
    "contactEmail": "Contact Email",
    "attachments": "Attachments",
    "couldNotOpenLink": "Could not open link",
    "approversInformation": "Approvers Information",
    "unknown": "Unknown",
    "errorLoadingProducts": "Error Loading Products",
    "noProductsAvailable": "No Products Available",
    "noExpensesInDraft": "No expenses in draft",
    "expenseDetails": "Expense Details",
    "nameUnset": "Name Unset",
    "totalAmount": "Total Amount",
    "employee": "Employee",
    "companyCurrency": "Company Currency",
    "currencyRate": "Currency Rate",
    "approvedBy": "Approved By",
    "approvedOn": "Approved On",
    "taxes": "Taxes",
    "areYouSureYouWantToDeleteThisExpense": "Are you sure you want to delete this expense?",
    "areYouSureYouWantToDeleteThisReport": "Are you sure you want to delete this report?",
    "currencyNotFound": "Currency not found",
    "notFound": "Not found",
    "errorSelectingCurrency": "Error selecting currency",
    "unnamedCurrency": "Unnamed currency",
    "noCurrencySelected": "No currency selected",
    "errorLoadingCurrencies": "Error loading currencies",
    "noCurrenciesAvailable": "No currencies available",
    "unnamedAccount": "Unnamed account",
    "errorLoadingAccounts": "Error loading accounts",
    "noAccountsAvailable": "No accounts available",
    "categoryNotFound": "Category not found",
    "errorSelectingCategory": "Error selecting category",
    "unnamedCategory": "Unnamed category",
    "editExpense": "Edit Expense",
    "editing": "Editing",
    "update": "Update",
    "errorLoadingProjects": "Error loading projects",
    "addProjects": "Add Projects",
    "allProjectsSelected": "All projects selected",
    "noProjectsAvailable": "No projects available",
    "unnamedSaleOrder": "Unnamed sale order",
    "errorLoadingSaleOrders": "Error loading sale orders",
    "noSaleOrdersAvailable": "No sale orders available",
    "vendorNotFound": "Vendor not found",
    "errorSelectingVendor": "Error selecting vendor",
    "unnamedVendor": "Unnamed vendor",
    "noVendorSelected": "No vendor selected",
    "errorLoadingVendors": "Error loading vendors",
    "noVendorsAvailable": "No vendors available",
    "areYouSureYouWantToDeleteThisLeave": "Are you sure you want to delete this leave?",
    "leaveIsDeletedSuccessfully": "Leave is deleted successfully",
    "leaveDetails": "Leave Details",
    "leaveNotFound": "Leave not found",
    "dateFrom": "Date From",
    "dateTo": "Date To",
    "numberOfDays": "Number of Days",
    "numberOfHours": "Number of Hours",
    "hourFrom": "Hour From",
    "hourTo": "Hour To",
    "approver": "Approver",
    "leaveUpdatedSuccessfully": "Leave updated successfully",
    "leaveSubmittedSuccessfully": "Leave submitted successfully",
    "updateLeave": "Update Leave",
    "yesUpdate": "Yes, Update",
    "selectDayPartSubtitle": "Select part of the day",
    "search": "Search",
    "untitledTask": "Untitled Task",
    "noTasksAssignedYet": "No tasks assigned yet",
    "updateTimeSheet": "Update Timesheet",
    "addTimeSheet": "Add Timesheet",
    "enterTime": "Enter Time",
    "timeAddedSuccessfully": "Time added successfully",
    "attachment": "Attachment",
    "items": "Items",
    "changeLanguage": "Change Language",
    "selectYourPreferredLanguage": "Select your preferred language",
    "taskStage": "Task Stage",
    "noStage": "No Stage",
    "updating": "Updating...",
    "errorLoadingStages": "Error loading stages",
    "loadingStages": "Loading stages...",
    "stageUpdatedTo": "Stage updated to",
    "failedToUpdateStage": "Failed to update stage",
    "selected": "Selected",
    "noStagesAvailable": "No stages available",
    "current": "Current",
    "updatingStage": "Updating stage...",
    "reasonOfRejection": "Reason of Rejection",
    "documents": "Documents",
    "noDocuments": "No documents found",
    "documentDetails": "Document Details",
    "createDocument": "Create Document",
    "editDocument": "Edit Document",
    "deleteDocument": "Delete Document",
    "deleteDocumentConfirmation": "Are you sure you want to delete this document?",
    "documentType": "Document Type",
    "issueDate": "Issue Date",
    "expiryDate": "Expiry Date",
    "systemInformation": "System Information",
    "createdBy": "Created by",
    "createdOn": "Created on",
    "lastUpdatedBy": "Last updated by",
    "notificationDays": "Notification Days",
    "notificationType": "Notification Type",
    "active": "Active",
    "expired": "Expired",
    "expiringSoon": "Expiring Soon",
    "valid": "Valid",
    "noExpiry": "No expiry",
    "expiredDocuments": "Expired Documents",
    "expiringDocuments": "Expiring Soon",
    "failedToFetchDocuments": "Failed to load documents. Please try again.",
    "failedToCreateDocument": "Failed to create document. Please try again.",
    "failedToUpdateDocument": "Failed to update document. Please try again.",
    "failedToDeleteDocument": "Failed to delete document. Please try again.",
    "documentCreatedSuccessfully": "Document created successfully",
    "documentUpdatedSuccessfully": "Document updated successfully",
    "documentDeletedSuccessfully": "Document deleted successfully",
    "noDocumentSelected": "No document selected",
    "invalidDocumentData": "Invalid document data. Please check the required fields.",
    "sessionExpired": "Session expired. Please log in again.",
    "accessDenied": "Access denied. You don't have permission to perform this action.",
    "networkError": "Network error occurred. Please check your internet connection.",
    "pleaseEnterDocumentName": "Please enter document name",
    "pleaseSelectDocumentType": "Please select document type",
    "pleaseSelectEmployee": "Please select employee",
    "invalidDate": "Invalid date format",
    "expiryDateBeforeIssueDate": "Expiry date cannot be before issue date",
    "documentNameRequired": "Document name is required",
    "documentTypeRequired": "Document type is required",
    "documentName": "Document Name",
    "selectDocumentType": "Select Document Type",
    "loadingDocumentTypes": "Loading document types...",
    "errorLoadingDocumentTypes": "Error loading document types",
    "noDocumentTypesAvailable": "No document types available",
    "documentNumber": "Document Number",
    "overdue": "Overdue",
    "created": "Created",
    "payslips": "Payslips",
    "viewYourSalarySlips": "View your salary slips",
    "noPayslips": "No payslips available",
    "payslipDetails": "Payslip Details",
    "noPayslipDetails": "No payslip details available",
    "pending": "Pending",
    "paid": "Paid",
    "earnings": "Earnings",
    "deductions": "Deductions",
    "other": "Other",
    "pendingPayslips": "Pending Payslips",
    "cancelled": "Cancelled",
    "unnamedPayslip": "Unnamed Payslip",
    "noNumber": "No Number",
    "basicWage": "Basic Wage",
    "grossWage": "Gross Wage",
    "netWage": "Net Wage",
    "from": "From",
    "unnamedItem": "Unnamed Item",
    "done": "Done",
    "salaryComputation": "Salary Computation",
    "workedDays": "Worked Days",
    "otherInfo": "Other Info",
    "workedDaysDescription": "Detailed breakdown of worked days, overtime, and holidays",
    "otherInfoDescription": "Additional payslip information and details",
    "payslipNumber": "Payslip Number",
    "contract": "Contract",
    "payStructure": "Pay Structure",
    "errorLoadingWorkedDays": "Error loading worked days",
    "noWorkedDays": "No worked days data",
    "noWorkedDaysDescription": "No worked days information available for this payslip period",
    "workedDaysSummary": "Worked Days Summary",
    "totalDays": "Total Days",
    "totalHours": "Total Hours",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "unpaid": "Unpaid",
    "creditTime": "Credit Time",
    "searchProjectsHint": "Search by project name or client...",
    "noProjectsFound": "No projects found",
    "tryDifferentKeywords": "Try different search terms",
    "searchTasksHint": "Search by task name...",
    "noTasksFound": "No tasks found",
    "showing": "Showing",
    "clearFilter": "Clear Filter",
    "allStages": "All Stages",
    "filterByStage": "Filter by Stage",
    "all": "All",
    "noDocumentsFound": "No documents found",
    "searchDocumentsHint": "Search documents (name, type, description)...",
    "userProfile": "User Profile",
    "contactInformation": "Contact Information",
    "jobInformation": "Job Information",
    "timeAttendance": "Time & Attendance",
    "emergencyContact": "Emergency Contact",
    "noProfileData": "No profile data available",
    "mobile": "Mobile",
    "personalEmail": "Personal Email",
    "personalPhone": "Personal Phone",
    "notProvided": "Not provided",
    "department": "Department",
    "jobPosition": "Job Position",
    "coach": "Coach",
    "workLocation": "Work Location",
    "workSchedule": "Work Schedule",
    "hourlyCost": "Hourly Cost",
    "checkedIn": "Checked In",
    "checkedOut": "Checked Out",
    "absent": "Absent",
    "lastMonth": "Last Month",
    "totalOvertime": "Total Overtime",
    "lastCheckIn": "Last Check-in",
    "lastCheckOut": "Last Check-out",
    "remaining": "Remaining",
    "totalAllocated": "Total Allocated",
    "used": "Used",
    "currentLeave": "Current Leave",
    "emergencyPhone": "Emergency Phone",
    "additionalContactInformation": "Additional Contact Information",
    "privatePhone": "Private Phone",
    "privateEmail": "Private Email",
    "noEmergencyContactSet": "No Emergency Contact Set",
    "pleaseUpdateEmergencyContact": "Please update your emergency contact information",
    "addEmergencyContact": "Add Emergency Contact",
    "editEmergencyContacts": "Edit Emergency Contacts",
    "emergencyContactName": "Emergency Contact Name",
    "enterPhoneNumber": "Enter phone number",
    "yourPersonalPhoneNumber": "Your personal phone number",
    "yourPersonalEmail": "Your personal email",
    "updatedSuccessfully": "updated successfully",
    "failedToUpdate": "Failed to update",
    "noChangesMade": "No changes were made",
    "isRequired": "is required",
    "notifications": "Notifications",
    "noNotifications": "No Notifications",
    "allCaughtUp": "You're all caught up!",
    "notification": "Notification",
    "byName": "By {name}",
    "sent": "Sent",
    "read": "Read",
    "justNow": "Just now",
    "dayAgo": "{count} day ago",
    "daysAgo": "{count} days ago",
    "hourAgo": "{count} hour ago",
    "hoursAgo": "{count} hours ago",
    "minuteAgo": "{count} minute ago",
    "minutesAgo": "{count} minutes ago",
    "markAsRead": "Mark as read",
    "markAllAsRead": "Mark all as read",
    "notificationDetails": "Notification Details",
    "failedToLoadNotifications": "Failed to load notifications",
    "noInternetConnectionNotifications": "No internet connection for notifications",
    "tapToMarkRead": "Tap to mark as read",
    "unreadNotifications": "Unread notifications",
    "success": "Success",
    "updated": "Updated",
    "privateTasks": "Private Tasks",
    "privateTasksDescription": "Tasks that are not assigned to any project",
    "messages": "Messages",
    "noMessages": "No messages",
    "messageHasError": "Message has error",
    "attentionRequired": "Attention required",
    "yesterday": "Yesterday",
    "messageDetails": "Message Details",
    "subject": "Subject",
    "message": "Message",
    "preview": "Preview",
    "details": "Details",
    "record": "Record",
    "messageSent": "Message Sent",
    "actionRequired": "Action Required",
    "view": "View",
    "loadingAttachments": "Loading attachments...",
    "noAttachments": "No attachments",
    "unknownFile": "Unknown file",
    "download": "Download",
    "open": "Open",
    "opening": "Opening",
    "errorOpeningFile": "Error opening file",
    "image": "Image",
    "autoRefreshOn": "Auto-refresh on",
    "autoRefreshOff": "Auto-refresh off",
    "refreshingMessages": "Refreshing messages...",
    "composeMessage": "Compose Message",
    "replyToMessage": "Reply to Message",
    "replyingTo": "Replying to",
    "subjectHint": "Enter subject...",
    "messageHint": "Type your message here...",
    "send": "Send",
    "subjectRequired": "Subject is required",
    "messageRequired": "Message is required",
    "noRecipients": "No recipients",
    "recipients": "recipients",
    "messageSentSuccessfully": "Message sent successfully",
    "deleteMessage": "Delete Message",
    "areYouSureYouWantToDeleteThisMessage": "Are you sure you want to delete this message?",
    "messageDeletedSuccessfully": "Message deleted successfully",
    "uploadDocumentTitle": "Upload Document",
    "documentNameLabel": "Document Name",
    "urlLabel": "URL",
    "addUrlButton": "Add URL Document",
    "documentsUploadedSuccessfully": "Documents uploaded successfully",
    "changePasswordTitle": "Change Password",
    "currentPassword": "Current Password",
    "currentPasswordHint": "Enter current password",
    "newPassword": "New Password",
    "newPasswordHint": "Enter new password",
    "confirmNewPassword": "Confirm New Password",
    "confirmNewPasswordHint": "Re-enter new password",
    "passwordChangedSuccess": "Password changed successfully",
    "invalidCurrentPassword": "Current password is incorrect",
    "changePasswordFailed": "Could not change password. Please try again.",
    "expiryWarning": "Your subscription expires in {daysRemaining} days ({expiryDate}). Please renew soon.",
    "expiryUrgentWarning": "URGENT: Your subscription expires in {daysRemaining} days ({expiryDate}). Please renew immediately!",
    "subscriptionExpiredTitle": "Subscription Expired",
    "subscriptionExpiredMessage": "Your subscription has expired. Please renew to continue using the app.",
    "subscriptionExpiredButton": "Renew Now",
    "subscriptionExpiredContactSupport": "Contact Support",
    "subscriptionExpiredGoBackToLogin": "Go Back to Login",
    "thisWeek": "This Week",
    "listView": "List View",
    "tableView": "Table View",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "thisMonth": "This Month",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "weekView": "Week",
    "monthView": "Month",
    "projectTask": "Project / Task",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Sun"
  },
  "ar": {
    "language": "العربية",
    "getStarted": "ابدأ الآن",
    "hello": "مرحبا {name}",
    "onboardingPageOneTitle": "مرحبًا بك في كرو كور",
    "onboardingPageTwoTitle": "رحلتك تبدأ من هنا",
    "onboardingPageThreeTitle": "لنبدأ الآن!",
    "onboardingBottomSheetTitle": "طريقة سهلة لتأكيد حضورك",
    "onboardingBottomSheetSubtitle": "هناك حقيقة مثبتة أن القارئ سيتشتت\nبسبب المحتوى المقروء.",
    "next": "التالي",
    "needHelp": "تحتاج مساعدة",
    "welcomeBack": "مرحبًا بعودتك!",
    "to": "إلى",
    "loginPageSubtitle": "مرحبًا، قم بتسجيل الدخول للمتابعة",
    "email": "البريد الإلكتروني",
    "emailHint": "أدخل بريدك الإلكتروني",
    "password": "كلمة المرور",
    "passwordHint": "أدخل كلمة المرور",
    "forgotPassword": "نسيت كلمة المرور؟",
    "doNotHaveAnAccount": "ليس لديك حساب؟ ",
    "haveAnAccount": "لديك حساب؟ ",
    "register": "سجل الآن",
    "orContinueWith": "أو تابع باستخدام",
    "login": "تسجيل الدخول",
    "firstName": "الاسم الأول",
    "firstNameHint": "أدخل اسمك الأول",
    "lastName": "اسم العائلة",
    "lastNameHint": "أدخل اسم عائلتك",
    "confirmPassword": "تأكيد كلمة المرور",
    "confirmPasswordHint": "أعد إدخال كلمة المرور",
    "iAgreeToThe": " أوافق على",
    "termsAndConditions": "الشروط والأحكام",
    "requiredField": "هذا الحقل مطلوب.",
    "invalidEmail": "يرجى إدخال بريد إلكتروني صالح.",
    "passwordTooShort": "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
    "passwordsDoNotMatch": "كلمتا المرور غير متطابقتين",
    "acceptTermsMessage": "يجب الموافقة على الشروط والأحكام للمتابعة.",
    "forgot_password": "نسيت كلمة المرور",
    "provide_mail": "يرجى تزويدنا بعنوان بريدك الإلكتروني",
    "doNot_worry": "لا تقلق",
    "send_email": "إرسال البريد الإلكتروني",
    "termsAndConditionsText": "مرحبًا بك في تطبيقنا. باستخدامك لهذا التطبيق، فإنك توافق على الالتزام بالشروط والأحكام التالية.\n\n١. قبول الشروط\nمن خلال إنشاء حساب أو استخدام خدماتنا، فإنك توافق على هذه الشروط وسياسة الخصوصية.\n\n٢. مسؤوليات المستخدم\n- يجب أن لا يقل عمرك عن 13 عامًا.\n- أنت مسؤول عن الحفاظ على سرية حسابك.\n- يجب تقديم معلومات دقيقة وحديثة وكاملة.\n\n٣. قيود الاستخدام\nأنت توافق على عدم:\n- استخدام التطبيق لأغراض غير قانونية.\n- التدخل في تشغيل التطبيق.\n- محاولة الوصول غير المصرح به.\n\n٤. الملكية الفكرية\nجميع المحتويات والبيانات هي ملكية فكرية لصاحب التطبيق ولا يجوز استخدامها دون إذن.\n\n٥. الإنهاء\nيجوز لنا تعليق أو إنهاء وصولك دون إشعار إذا انتهكت هذه الشروط.\n\n٦. إخلاء المسؤولية\nيتم توفير هذا التطبيق \"كما هو\" بدون أي ضمانات من أي نوع.\n\n٧. التعديلات على الشروط\nيجوز لنا تعديل هذه الشروط في أي وقت. ويعد استمرار الاستخدام قبولًا للتعديلات.\n\n٨. اتصل بنا\nإذا كانت لديك أي أسئلة، راسلنا على support@example.com",
    "noInternetMessage": "لا يوجد اتصال بالإنترنت. يرجى التحقق من الاتصال.",
    "unknownError": "حدث خطأ غير معروف. يرجى المحاولة مرة أخرى لاحقًا.",
    "invalidEmailOrPassword": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    "wrongPassword": "كلمة المرور غير صحيحة. يرجى التحقق من كلمة المرور.",
    "userNotFound": "المستخدم غير موجود. يرجى التحقق من بيانات الاعتماد الخاصة بك.",
    "companyNotFound": "الشركة غير موجودة. يرجى التحقق من اسم الشركة.",
    "invalidToken": "رمز الجلسة غير صالح. يرجى تسجيل الدخول مرة أخرى.",
    "genericLoginError": "حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقًا.",
    "congratulations": "تهانينا",
    "yourAccountIsReadyToUse": "حسابك جاهز للاستخدام!",
    "resetEmailSent": "تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور.",
    "enableBiometrics": "تفعيل تسجيل الدخول البيومتري؟",
    "enableBiometricsDescription": "هل ترغب في تسجيل الدخول بسرعة باستخدام بصمتك أو وجهك في المرة القادمة؟",
    "loginWithBiometrics": "تسجيل الدخول باستخدام البيانات البيومترية",
    "yes": "نعم",
    "no": "لا",
    "biometricsNotFound": "لم يتم العثور على بصمة! الرجاء تسجيل الدخول مرة أخرى",
    "resetPasswordTitle": "إعادة تعيين كلمة المرور؟",
    "resetPasswordWarning": "إذا قمت بإعادة تعيين كلمة المرور، سيتم تعطيل تسجيل الدخول بالبصمة. ستحتاج إلى تسجيل الدخول مرة أخرى وتفعيله.",
    "cancel": "إلغاء",
    "continueText": "متابعة",
    "googleSignInFailed": "تم إلغاء تسجيل الدخول باستخدام Google أو فشل",
    "myWorkSummary": "ملخص عملي",
    "myWorkSummarySubtitle": "مهام اليوم ونشاط الحضور",
    "todaysAttendance": "حضور اليوم",
    "totalWorkingHours": "إجمالي ساعات العمل",
    "today": "اليوم",
    "breaksToday": "استراحات اليوم",
    "clockIn": "تسجيل الدخول",
    "backToWork": "العودة للعمل",
    "takeABreak": "أخذ استراحة",
    "clockOut": "تسجيل الخروج",
    "hoursLabel": "{hours}:{minutes} س",
    "paidPeriod": "الفترة المدفوعة {start} - {end}",
    "period": "الفترة {start} - {end}",
    "clockInAreaTitle": "أنت الآن في منطقة تسجيل الدخول!",
    "clockInAreaDescription": "يمكنك الضغط على تسجيل الدخول في هذه المنطقة",
    "notInClockInAreaTitle": "أنت خارج منطقة تسجيل الحضور!",
    "notInClockOutAreaTitle": "أنت خارج منطقة تسجيل الخروج!",
    "notInClockInAreaDescription": "لا يمكنك التسجيل في هذه المنطقة",
    "myProfileSection": "ملفي الشخصي",
    "scheduleSection": "الجدول",
    "clockInAreaLabel": "منطقة تسجيل الدخول",
    "fetchingLocation": "جلب الموقع…",
    "error": "خطأ",
    "yourActivity": "نشاطك",
    "activity": "النشاط",
    "onTime": "في الوقت المحدد",
    "viewAll": "عرض الكل",
    "confirmClockOutTitle": "تأكيد تسجيل الخروج",
    "confirmClockOutMessage": "بمجرد تسجيل الخروج، لن تتمكن من تعديل هذا الوقت. يرجى التأكد من ساعات عملك قبل المتابعة.",
    "noLetMeCheck": "لا، دعني أتحقق",
    "thisPayPeriod": "الفترة المدفوعة",
    "locationUnavailable": "الموقع غير متاح",
    "locationUnavailableMessage": "لا يمكن تحديد موقعك في الوقت الحالي. يرجى التأكد من تمكين خدمات الموقع.",
    "noInternetActionSaved": "لا يوجد اتصال بالإنترنت. تم حفظ الإجراء محلياً وسيتم مزامنته عند استعادة الاتصال.",
    "manager": "المدير",
    "client": "العميل",
    "tasks": "المهام",
    "projects": "المشاريع",
    "projectsSubtitle": "المشاريع المخصصة لك",
    "tasksSubtitle": "المهام الموكلة إليك",
    "home": "الرئيسية",
    "attendance": "الحضور",
    "more": "المزيد",
    "pleaseWaitOneMinute": "يرجى الانتظار دقيقة واحدة على الأقل بين كل إجراء وآخر.",
    "leaveSummary": "ملخص الإجازات",
    "submitLeave": "تقديم إجازة",
    "available": "المتاح",
    "leaveUsed": "الإجازات المستخدمة",
    "review": "قيد المراجعة",
    "approved": "تمت الموافقة",
    "rejected": "مرفوض",
    "leaveDate": "تاريخ الإجازة",
    "approvedAt": "تاريخ الموافقة",
    "rejectedAt": "تاريخ الرفض",
    "expenseSummary": "ملخص المصاريف",
    "claimYourExpensesHere": "قدّم مصاريفك هنا.",
    "totalExpense": "إجمالي المصاريف",
    "totalLeave": "إجمالي الإجازات",
    "total": "الإجمالي",
    "type": "النوع",
    "allApprovals": "كل الموافقات",
    "totalApprovals": "إجمالي الموافقات",
    "noLeaveSubmitted": "لم يتم تقديم أي إجازة!",
    "noLeaveApproved": "لا توجد إجازات تمت الموافقة عليها!",
    "noLeaveRejected": "لا توجد إجازات مرفوضة!",
    "noLeaveSubmittedSubtitle": "مستعد لأخذ استراحة؟ اضغط على \"تقديم إجازة\" وخذ قسطًا من الراحة المستحقة!",
    "noExpenseSubmitted": "لم يتم تقديم أي مصروف!",
    "noExpenseApproved": "لا توجد مصاريف تمت الموافقة عليها!",
    "noExpenseRejected": "لا توجد مصاريف مرفوضة!",
    "noExpenseSubtitle": "يبدو أنه لا توجد مصاريف مسجلة. لا تقلق، سيتم تحديث هذه المساحة عند وجود بيانات جديدة.",
    "noApprovalSubmitted": "لم يتم تقديم أي موافقة!",
    "noApprovalApproved": "لا توجد موافقات تمت الموافقة عليها!",
    "noApprovalRejected": "لا توجد موافقات مرفوضة!",
    "noApprovalSubtitle": "يبدو أنه لا توجد موافقات مسجلة. لا تقلق، سيتم تحديث هذه المساحة عند توفر بيانات جديدة.",
    "leaveSubmitted": "الإجازات المقدمة",
    "leaveInformation": "معلومات الإجازة",
    "expensesSubmitted": "المصاريف المقدمة",
    "expensesInformation": "معلومات المصاريف",
    "approvalSubmitted": "الموافقات المقدمة",
    "approvalInformation": "معلومات الموافقة",
    "pleaseSelectLeaveCategory": "يرجى اختيار نوع الإجازة",
    "pleaseSelectLeaveDuration": "يرجى تحديد مدة الإجازة",
    "pleaseSelectTaskDelegation": "يرجى اختيار التفويض",
    "submitLeaveMessage": "تحقق من تفاصيل الإجازة بعناية للتأكد من صحتها. هل ترغب في المتابعة؟",
    "submitMessage": "تحقق من التفاصيل بعناية للتأكد من صحتها. هل ترغب في المتابعة؟",
    "submitText": "نعم، قدم",
    "fillLeaveInformation": "املأ معلومات الإجازة",
    "informationAboutLeaveDetails": "معلومات حول تفاصيل الإجازة",
    "leaveCategory": "نوع الإجازة",
    "selectLeaveCategory": "اختر نوع الإجازة",
    "leaveDuration": "مدة الإجازة",
    "selectDuration": "اختر المدة",
    "taskDelegation": "تفويض المهمة",
    "selectTaskDelegation": "اختر التفويض",
    "emergencyContactDuringLeavePeriod": "جهة الاتصال في حالة الطوارئ خلال فترة الإجازة",
    "pleaseEnterContactNumber": "يرجى إدخال رقم الاتصال",
    "numberTooShort": "الرقم قصير جدًا",
    "leaveDescription": "وصف الإجازة",
    "enterLeaveDescription": "أدخل وصف الإجازة",
    "pleaseEnterDescription": "يرجى إدخال وصف",
    "selectCategory": "اختر الفئة",
    "leaveRequest": "طلب إجازة",
    "expenseRequest": "طلب مصروفات",
    "approvalRequest": "طلب موافقة",
    "leavesApproved": "الإجازات الموافق عليها",
    "leavesRejected": "الإجازات المرفوضة",
    "expensesApproved": "المصروفات الموافق عليها",
    "expensesRejected": "المصروفات المرفوضة",
    "approvalsApproved": "الموافقات المعتمدة",
    "approvalsRejected": "الموافقات المرفوضة",
    "submitExpense": "تقديم المصروف",
    "fillClaimInformation": "املأ معلومات المطالبة",
    "informationAboutClaimDetails": "معلومات عن تفاصيل المطالبة",
    "expenseCategory": "فئة المصروف",
    "selectExpenseCategory": "اختر فئة المصروف",
    "paidBy": "دفع بواسطة",
    "selectEmployeeOrCompany": "اختر الموظف أو الشركة",
    "expenseDate": "تاريخ المصروف",
    "enterTransactionDate": "أدخل تاريخ المعاملة",
    "expenseAmount": "مبلغ المصروف",
    "enterAmount": "أدخل المبلغ",
    "expenseDescription": "وصف المصروف",
    "enterExpenseDescription": "أدخل وصف المصروف",
    "uploadClaimDocument": "تحميل المستند",
    "selectApprovalCategory": "اختر فئة الموافقة",
    "enterDate": "أدخل التاريخ",
    "enterPeriod": "أدخل الفترة",
    "submitApproval": "إرسال الموافقة",
    "fillApprovalInformation": "املأ معلومات الموافقة",
    "informationAboutApprovalDetails": "معلومات حول تفاصيل الموافقة",
    "approvalCategory": "فئة الموافقة",
    "requestOwner": "صاحب الطلب",
    "location": "الموقع",
    "pleaseEnterLocation": "يرجى إدخال الموقع",
    "date": "التاريخ",
    "periodd": "الفترة",
    "reference": "المرجع",
    "pleaseEnterReference": "يرجى إدخال المرجع",
    "contact": "جهة الاتصال",
    "pleaseEnterContact": "يرجى إدخال جهة الاتصال",
    "uploadFile": "رفع الملف",
    "approvalDescription": "وصف الموافقة",
    "enterApprovalDescription": "أدخل وصف الموافقة",
    "quantity": "الكمية",
    "enterQuantity": "أدخل الكمية",
    "pleaseEnterQuantity": "يرجى إدخال كمية صالحة",
    "quantityMustBePositiveNumber": "يجب أن تكون الكمية رقمًا موجبًا",
    "product": "المنتج",
    "addProduct": "إضافة منتج",
    "productName": "اسم المنتج",
    "description": "الوصف",
    "close": "إغلاق",
    "add": "إضافة",
    "requests": "الطلبات",
    "title": "العنوان",
    "pleaseEnterTitle": "يرجى إدخال العنوان",
    "errorLoadingCategories": "حدث خطأ أثناء تحميل الفئات.",
    "noCategoriesAvailable": "لا توجد فئات متاحة.",
    "amount": "المبلغ",
    "errorLoadingContacts": "حدث خطأ أثناء تحميل جهات الاتصال",
    "name": "الاسم",
    "enterName": "ادخل الاسم",
    "pleaseEnterName": "يرجى إدخال الاسم.",
    "enterValidAmount": "يرجى إدخال مبلغ صحيح.",
    "account": "الحساب",
    "selectAccount": "اختر الحساب",
    "selectExpenseAccount": "اختر حساب المصروف",
    "vendor": "المورّد",
    "selectVendor": "اختر المورّد",
    "selectExpenseVendor": "اختر مورّد المصروف",
    "saleOrder": "أمر البيع",
    "selectSaleOrder": "اختر أمر البيع",
    "selectExpenseSaleOrder": "اختر أمر بيع المصروف",
    "submitNow": "أرسل الآن",
    "currency": "العملة",
    "selectCurrency": "اختر العملة",
    "selectExpenseCurrency": "اختر عملة المصروف",
    "customerToReinvoice": "العميل لإعادة إصدار الفاتورة",
    "selectCustomerToReinvoice": "اختر العميل لإعادة إصدار الفاتورة",
    "pleaseEnterStartDate": "يرجى إدخال تاريخ البدء.",
    "pleaseEnterEndDate": "يرجى إدخال تاريخ الانتهاء.",
    "startDate": "تاريخ البدء",
    "endDate": "تاريخ الانتهاء",
    "pleaseEnterStartTime": "يرجى إدخال وقت البدء.",
    "pleaseEnterEndTime": "يرجى إدخال وقت الانتهاء.",
    "startTime": "وقت البدء",
    "endTime": "وقت الانتهاء",
    "pleaseSelectDayPart": "يرجى اختيار جزء من اليوم.",
    "hourBasedLeave": "إجازة حسب الساعات",
    "halfDayLeave": "نصف يوم إجازة",
    "selectStartTime": "اختر وقت البدء",
    "selectEndTime": "اختر وقت الانتهاء",
    "selectDayPart": "اختر الجزء من اليوم",
    "dayPart": "الجزء من اليوم",
    "categoryLeaveDaysExceeded": "عدد أيام الإجازة يتجاوز الحد المسموح به لهذه الفئة.",
    "allowedDays": "الأيام المسموح بها:",
    "allowedHours": "الساعات المسموح بها:",
    "endTimeMustBeAfterStartTime": "وقت النهاية يجب أن يكون بعد وقت البداية",
    "categoryLeaveBalanceExceeded": "الإجازة المطلوبة تتجاوز رصيدك المتبقي",
    "hr": "الموارد البشرية",
    "employees": "الموظفين",
    "viewAndEditYourEmployeesData": "عرض وتعديل بيانات الموظفين",
    "employeesInformation": "معلومات الموظفين",
    "noName": "لا يوجد اسم",
    "noEmail": "لا يوجد بريد إلكتروني",
    "noPhone": "لا يوجد هاتف",
    "noType": "لا يوجد نوع",
    "changesSavedSuccessfully": "تم حفظ التغييرات بنجاح!",
    "editModeEnabled": "تم تفعيل وضع التحرير",
    "confirmDelete": "تأكيد الحذف",
    "areYouSureYouWantToDeleteThisEmployee": "هل أنت متأكد أنك تريد حذف هذا الموظف؟",
    "thisActionCannotBeUndone": "هذا الإجراء لا يمكن التراجع عنه",
    "delete": "حذف",
    "employeeDeletedSuccessfully": "تم حذف الموظف بنجاح",
    "addLocation": "إضافة موقع",
    "locationName": "اسم الموقع",
    "address": "العنوان",
    "locationAddedSuccessfully": "تمت إضافة الموقع بنجاح",
    "employeeDetails": "تفاصيل الموظف",
    "employeeInformation": "معلومات الموظف",
    "fullName": "الاسم الكامل",
    "workEmail": "البريد الإلكتروني للعمل",
    "workPhone": "هاتف العمل",
    "employeeType": "نوع الموظف",
    "departmentID": "معرف القسم",
    "companyInformation": "معلومات الشركة",
    "company": "الشركة",
    "notSpecified": "غير محدد",
    "categories": "الفئات",
    "none": "لا يوجد",
    "assignedLocations": "المواقع المخصصة",
    "noLocationsAssigned": "لا توجد مواقع مخصصة",
    "saveChanges": "حفظ التغييرات",
    "employeeAlreadyExists": "الموظف موجود بالفعل",
    "createNewEmployee": "إنشاء موظف جديد",
    "employeeName": "اسم الموظف",
    "enterFullName": "أدخل الاسم الكامل",
    "pleaseEnterEmployeeName": "الرجاء إدخال اسم الموظف",
    "enterWorkEmail": "أدخل البريد الإلكتروني للعمل",
    "pleaseEnterEmailAddress": "الرجاء إدخال عنوان البريد الإلكتروني",
    "pleaseEnterAValidEmail": "الرجاء إدخال بريد إلكتروني صالح",
    "createEmployee": "إنشاء موظف",
    "byCreatingThisProfileYouAgreeToOurTermsOfService": "بإنشاء هذا الملف الشخصي، فإنك توافق على شروط الخدمة لدينا",
    "employeeCreatedSuccessfully": "تم إنشاء الموظف بنجاح!",
    "hasBeenAddedToYourTeam": "تمت إضافته إلى فريقك",
    "backToEmployees": "العودة إلى الموظفين",
    "pleaseEnter": "الرجاء إدخال",
    "addNewTeamMember": "إضافة عضو جديد للفريق",
    "fillInTheDetailsToCreateANewEmployeeProfile": "املأ التفاصيل لإنشاء ملف موظف جديد",
    "deadline": "الموعد النهائي",
    "progress": "التقدم",
    "status": "الحالة",
    "assignees": "المكلفون",
    "timesheets": "جداول الدوام",
    "taskId": "معرّف المهمة",
    "project": "المشروع",
    "task": "المهمة",
    "selectTask": "اختر مهمة",
    "allProjects": "كل المشاريع",
    "allTasks": "كل المهام",
    "addTimesheet": "إضافة جدول دوام",
    "quickAdd": "إضافة سريعة",
    "loading": "جارٍ التحميل...",
    "timesheetAddedSuccessfully": "تمت إضافة جدول الدوام بنجاح",
    "noTimesheetRecordsYet": "لا توجد سجلات لجداول الدوام بعد",
    "enterDescription": "أدخل الوصف",
    "timesheetDeletedSuccessfully": "تم حذف جدول الدوام بنجاح",
    "edit": "تعديل",
    "editTimesheet": "تعديل الجدول الزمني",
    "currentSession": "الجلسة الحالية",
    "locationDisabled": "خدمات الموقع معطلة",
    "enableLocationMessage": "يرجى تمكين خدمات الموقع في إعدادات الجهاز.",
    "settings": "الإعدادات",
    "microphonePermissionNotGranted": "لم يتم منح إذن استخدام الميكروفون",
    "microphoneAccessNeeded": "مطلوب الوصول إلى الميكروفون",
    "thisAppNeedsMicrophoneAccessToRecordVoiceNotesForYourTimesheets": "يحتاج هذا التطبيق إلى الوصول إلى الميكروفون لتسجيل الملاحظات الصوتية لجداولك الزمنية.",
    "deny": "رفض",
    "allow": "سماح",
    "microphonePermissionIsRequiredToRecordAudio": "إذن الميكروفون مطلوب لتسجيل الصوت",
    "failedToPlayRecording": "فشل تشغيل التسجيل",
    "voiceNote": "ملاحظة صوتية",
    "recording": "جارٍ التسجيل",
    "duration": "المدة",
    "stopRecording": "إيقاف التسجيل",
    "recordNow": "سجّل الآن",
    "addExpense": "إضافة مصروف",
    "submitExpenseReport": "إرسال تقرير المصاريف",
    "reportInformation": "معلومات التقرير",
    "informationAboutReportDetails": "معلومات حول تفاصيل التقرير",
    "reportName": "اسم التقرير",
    "enterReportName": "أدخل اسم التقرير",
    "pleaseEnterReportName": "من فضلك أدخل اسم التقرير",
    "expenses": "المصاريف",
    "submitReport": "إرسال التقرير",
    "expenseReport": "تقرير المصاريف",
    "savedExpenses": "المصاريف المحفوظة",
    "expensesInProgress": "المصاريف الجارية",
    "saveExpense": "حفظ المصروف",
    "expenseSaved": "تم حفظ المصروف",
    "selectProject": "اختر مشروع",
    "submitForReview": "إرسال للمراجعة",
    "submit": "إرسال",
    "save": "حفظ",
    "submitToReview": "إرسال للمراجعة",
    "pleaseFillAllRequiredFields": "يرجى ملء جميع الحقول المطلوبة",
    "reportSaved": "تم حفظ التقرير",
    "reportSubmitted": "تم إرسال التقرير",
    "addAtLeastOneExpense": "أضف مصروفًا واحدًا على الأقل",
    "fixExpenseErrors": "إصلاح أخطاء المصاريف",
    "fixExpenseErrorsBeforeSubmit": "أصلح أخطاء المصاريف قبل الإرسال",
    "submissionFailed": "فشل الإرسال",
    "audioPlayback": "تشغيل الصوت",
    "failedToLoadAudio": "فشل في تحميل الصوت",
    "failedToPlayAudio": "فشل في تشغيل الصوت",
    "failedToStopAudio": "فشل في إيقاف الصوت",
    "failedToSeekAudio": "فشل في تغيير موضع الصوت",
    "loadingAudio": "جاري تحميل الصوت...",
    "retry": "إعادة المحاولة",
    "reportDeleted": "تم حذف التقرير بنجاح",
    "draft": "مسودة",
    "reportUpdated": "تم تحديث التقرير بنجاح",
    "rememberMe": "تذكرني",
    "loggingInTo": "تسجيل الدخول إلى",
    "yourLastOrganization": "مؤسستك الأخيرة",
    "clockingOutFrom": "تسجيل الخروج من",
    "clockingOut": "تسجيل الخروج",
    "clockingInFrom": "تسجيل الدخول من",
    "clockingIn": "تسجيل الدخول",
    "youCanPressClockIn": "يمكنك الضغط على تسجيل الدخول",
    "youCanPressClockOut": "يمكنك الضغط على تسجيل الخروج",
    "thereWasNoChangesApplied": "لم يتم تطبيق أي تغييرات",
    "fromTo": "من - إلى",
    "time": "الوقت",
    "by": "بواسطة",
    "requestDetails": "تفاصيل الطلب",
    "products": "المنتجات",
    "approval": "الموافقة",
    "recordOn": "تم التسجيل في",
    "category": "الفئة",
    "lastUpdatedOn": "آخر تحديث في",
    "dateSet": "تاريخ التعيين",
    "contactName": "اسم جهة الاتصال",
    "contactEmail": "البريد الإلكتروني لجهة الاتصال",
    "attachments": "المرفقات",
    "couldNotOpenLink": "تعذّر فتح الرابط",
    "approversInformation": "معلومات الموافقين",
    "unknown": "غير معروف",
    "errorLoadingProducts": "خطأ في تحميل المنتجات",
    "noProductsAvailable": "لا توجد منتجات متاحة",
    "noExpensesInDraft": "لا توجد مصروفات في المسودات",
    "expenseDetails": "تفاصيل المصروف",
    "nameUnset": "الاسم غير محدد",
    "totalAmount": "المبلغ الإجمالي",
    "employee": "الموظف",
    "companyCurrency": "عملة الشركة",
    "currencyRate": "سعر الصرف",
    "approvedBy": "تمت الموافقة بواسطة",
    "approvedOn": "تاريخ الموافقة",
    "taxes": "الضرائب",
    "areYouSureYouWantToDeleteThisExpense": "هل أنت متأكد أنك تريد حذف هذا المصروف؟",
    "areYouSureYouWantToDeleteThisReport": "هل أنت متأكد أنك تريد حذف هذا التقرير؟",
    "currencyNotFound": "العملة غير موجودة",
    "notFound": "غير موجود",
    "errorSelectingCurrency": "خطأ أثناء اختيار العملة",
    "unnamedCurrency": "عملة بدون اسم",
    "noCurrencySelected": "لم يتم اختيار عملة",
    "errorLoadingCurrencies": "خطأ في تحميل العملات",
    "noCurrenciesAvailable": "لا توجد عملات متاحة",
    "unnamedAccount": "حساب بدون اسم",
    "errorLoadingAccounts": "خطأ في تحميل الحسابات",
    "noAccountsAvailable": "لا توجد حسابات متاحة",
    "categoryNotFound": "الفئة غير موجودة",
    "errorSelectingCategory": "خطأ أثناء اختيار الفئة",
    "unnamedCategory": "فئة بدون اسم",
    "editExpense": "تعديل المصروف",
    "editing": "جارٍ التعديل",
    "update": "تحديث",
    "errorLoadingProjects": "خطأ في تحميل المشاريع",
    "addProjects": "إضافة مشاريع",
    "allProjectsSelected": "تم تحديد جميع المشاريع",
    "noProjectsAvailable": "لا توجد مشاريع متاحة",
    "unnamedSaleOrder": "طلب بيع بدون اسم",
    "errorLoadingSaleOrders": "خطأ في تحميل أوامر البيع",
    "noSaleOrdersAvailable": "لا توجد أوامر بيع متاحة",
    "vendorNotFound": "المورّد غير موجود",
    "errorSelectingVendor": "خطأ أثناء اختيار المورّد",
    "unnamedVendor": "مورّد بدون اسم",
    "noVendorSelected": "لم يتم اختيار مورّد",
    "errorLoadingVendors": "خطأ في تحميل المورّدين",
    "noVendorsAvailable": "لا يوجد مورّدون متاحون",
    "areYouSureYouWantToDeleteThisLeave": "هل أنت متأكد أنك تريد حذف هذه الإجازة؟",
    "leaveIsDeletedSuccessfully": "تم حذف الإجازة بنجاح",
    "leaveDetails": "تفاصيل الإجازة",
    "leaveNotFound": "الإجازة غير موجودة",
    "dateFrom": "من تاريخ",
    "dateTo": "إلى تاريخ",
    "numberOfDays": "عدد الأيام",
    "numberOfHours": "عدد الساعات",
    "hourFrom": "من الساعة",
    "hourTo": "إلى الساعة",
    "approver": "الموافق",
    "leaveUpdatedSuccessfully": "تم تحديث الإجازة بنجاح",
    "leaveSubmittedSuccessfully": "تم تقديم الإجازة بنجاح",
    "updateLeave": "تحديث الإجازة",
    "yesUpdate": "نعم، تحديث",
    "selectDayPartSubtitle": "اختر جزء اليوم",
    "search": "بحث",
    "untitledTask": "مهمة بدون عنوان",
    "noTasksAssignedYet": "لم يتم تعيين مهام بعد",
    "updateTimeSheet": "تحديث سجل الدوام",
    "addTimeSheet": "إضافة سجل دوام",
    "enterTime": "أدخل الوقت",
    "timeAddedSuccessfully": "تمت إضافة الوقت بنجاح",
    "attachment": "مرفق",
    "items": "عناصر",
    "logout": "تسجيل الخروج",
    "changeLanguage": "تغيير اللغة",
    "selectYourPreferredLanguage": "اختر لغتك المفضلة",
    "taskStage": "مرحلة المهمة",
    "noStage": "لا توجد مرحلة",
    "updating": "جاري التحديث...",
    "errorLoadingStages": "خطأ في تحميل المراحل",
    "loadingStages": "جاري تحميل المراحل...",
    "stageUpdatedTo": "تم تحديث المرحلة إلى",
    "failedToUpdateStage": "فشل في تحديث المرحلة",
    "selected": "محدد",
    "noStagesAvailable": "لا توجد مراحل متاحة",
    "current": "الحالي",
    "updatingStage": "جاري تحديث المرحلة...",
    "reasonOfRejection": "سبب الرفض",
    "documents": "المستندات",
    "noDocuments": "لا توجد مستندات",
    "documentDetails": "تفاصيل المستند",
    "createDocument": "إنشاء مستند",
    "editDocument": "تعديل المستند",
    "deleteDocument": "حذف المستند",
    "deleteDocumentConfirmation": "هل أنت متأكد من رغبتك في حذف هذا المستند؟",
    "documentType": "نوع المستند",
    "issueDate": "تاريخ الإصدار",
    "expiryDate": "تاريخ الانتهاء",
    "systemInformation": "معلومات النظام",
    "createdBy": "تم الإنشاء بواسطة",
    "createdOn": "تم الإنشاء في",
    "lastUpdatedBy": "تم التحديث الأخير بواسطة",
    "notificationDays": "أيام الإشعار",
    "notificationType": "نوع الإشعار",
    "active": "نشط",
    "expired": "منتهي",
    "expiringSoon": "ينتهي قريباً",
    "valid": "ساري",
    "noExpiry": "بدون انتهاء",
    "expiredDocuments": "المستندات المنتهية",
    "expiringDocuments": "تنتهي قريباً",
    "failedToFetchDocuments": "فشل تحميل المستندات. يرجى المحاولة مرة أخرى.",
    "failedToCreateDocument": "فشل إنشاء المستند. يرجى المحاولة مرة أخرى.",
    "failedToUpdateDocument": "فشل تحديث المستند. يرجى المحاولة مرة أخرى.",
    "failedToDeleteDocument": "فشل حذف المستند. يرجى المحاولة مرة أخرى.",
    "documentCreatedSuccessfully": "تم إنشاء المستند بنجاح",
    "documentUpdatedSuccessfully": "تم تحديث المستند بنجاح",
    "documentDeletedSuccessfully": "تم حذف المستند بنجاح",
    "noDocumentSelected": "لم يتم اختيار مستند",
    "invalidDocumentData": "بيانات المستند غير صالحة. يرجى التحقق من الحقول المطلوبة.",
    "sessionExpired": "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    "accessDenied": "تم رفض الوصول. ليس لديك صلاحية لتنفيذ هذا الإجراء.",
    "networkError": "حدث خطأ في الشبكة. يرجى التحقق من اتصال الإنترنت.",
    "pleaseEnterDocumentName": "يرجى إدخال اسم المستند",
    "pleaseSelectDocumentType": "يرجى اختيار نوع المستند",
    "pleaseSelectEmployee": "يرجى اختيار الموظف",
    "invalidDate": "صيغة التاريخ غير صالحة",
    "expiryDateBeforeIssueDate": "لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ الإصدار",
    "documentNameRequired": "اسم المستند مطلوب",
    "documentTypeRequired": "نوع المستند مطلوب",
    "documentName": "اسم المستند",
    "selectDocumentType": "اختر نوع المستند",
    "loadingDocumentTypes": "جاري تحميل أنواع المستندات...",
    "errorLoadingDocumentTypes": "خطأ في تحميل أنواع المستندات",
    "noDocumentTypesAvailable": "لا توجد أنواع مستندات متاحة",
    "documentNumber": "رقم المستند",
    "overdue": "متأخر",
    "created": "تم الإنشاء",
    "payslips": "إيصالات الرواتب",
    "viewYourSalarySlips": "عرض إيصالات راتبك",
    "noPayslips": "لا توجد إيصالات رواتب متاحة",
    "payslipDetails": "تفاصيل إيصال الراتب",
    "noPayslipDetails": "لا توجد تفاصيل لإيصال الراتب",
    "pending": "قيد الانتظار",
    "paid": "مدفوعة",
    "earnings": "الإيرادات",
    "deductions": "الخصومات",
    "other": "أخرى",
    "pendingPayslips": "إيصالات الرواتب المعلقة",
    "cancelled": "ملغية",
    "unnamedPayslip": "إيصال راتب بدون اسم",
    "noNumber": "لا يوجد رقم",
    "basicWage": "الأجر الأساسي",
    "grossWage": "الأجر الإجمالي",
    "netWage": "صافي الأجر",
    "from": "من",
    "unnamedItem": "عنصر بدون اسم",
    "done": "مكتمل",
    "salaryComputation": "حساب الراتب",
    "workedDays": "أيام العمل",
    "otherInfo": "معلومات أخرى",
    "workedDaysDescription": "تفصيل مفصل لأيام العمل، العمل الإضافي، والإجازات",
    "otherInfoDescription": "معلومات وتفاصيل إضافية عن إيصال الراتب",
    "payslipNumber": "رقم إيصال الراتب",
    "contract": "العقد",
    "payStructure": "هيكل الأجر",
    "errorLoadingWorkedDays": "خطأ في تحميل أيام العمل",
    "noWorkedDays": "لا توجد بيانات أيام عمل",
    "noWorkedDaysDescription": "لا توجد معلومات عن أيام العمل متاحة لفترة إيصال الراتب هذه",
    "workedDaysSummary": "ملخص أيام العمل",
    "totalDays": "إجمالي الأيام",
    "totalHours": "إجمالي الساعات",
    "days": "أيام",
    "hours": "ساعات",
    "minutes": "دقائق",
    "unpaid": "غير مدفوع",
    "creditTime": "وقت الائتمان",
    "searchProjectsHint": "ابحث باسم المشروع أو العميل...",
    "noProjectsFound": "لم يتم العثور على مشاريع",
    "tryDifferentKeywords": "جرّب كلمات بحث مختلفة",
    "searchTasksHint": "ابحث حسب اسم المهمة...",
    "noTasksFound": "لم يتم العثور على مهام",
    "showing": "عرض",
    "clearFilter": "مسح الفلتر",
    "allStages": "كل المراحل",
    "filterByStage": "تصفية حسب المرحلة",
    "all": "الكل",
    "noDocumentsFound": "لم يتم العثور على مستندات",
    "searchDocumentsHint": "ابحث في المستندات (الاسم، النوع، الوصف)...",
    "userProfile": "الملف الشخصي",
    "contactInformation": "معلومات الاتصال",
    "jobInformation": "معلومات الوظيفة",
    "timeAttendance": "الوقت والحضور",
    "emergencyContact": "جهة اتصال الطوارئ",
    "noProfileData": "لا توجد بيانات للملف الشخصي",
    "mobile": "الجوال",
    "personalEmail": "البريد الإلكتروني الشخصي",
    "personalPhone": "الهاتف الشخصي",
    "notProvided": "غير مقدم",
    "department": "القسم",
    "jobPosition": "المسمى الوظيفي",
    "coach": "المدرب",
    "workLocation": "موقع العمل",
    "workSchedule": "جدول العمل",
    "hourlyCost": "التكلفة بالساعة",
    "checkedIn": "تم التسجيل",
    "checkedOut": "تم الخروج",
    "absent": "غائب",
    "lastMonth": "الشهر الماضي",
    "totalOvertime": "إجمالي الوقت الإضافي",
    "lastCheckIn": "آخر تسجيل دخول",
    "lastCheckOut": "آخر تسجيل خروج",
    "remaining": "المتبقي",
    "totalAllocated": "إجمالي المخصص",
    "used": "المستخدم",
    "currentLeave": "الإجازة الحالية",
    "emergencyPhone": "هاتف الطوارئ",
    "additionalContactInformation": "معلومات الاتصال الإضافية",
    "privatePhone": "الهاتف الخاص",
    "privateEmail": "البريد الإلكتروني الخاص",
    "noEmergencyContactSet": "لم يتم تعيين جهة اتصال للطوارئ",
    "pleaseUpdateEmergencyContact": "يرجى تحديث معلومات جهة اتصال الطوارئ",
    "addEmergencyContact": "إضافة جهة اتصال للطوارئ",
    "editEmergencyContacts": "تعديل جهات اتصال الطوارئ",
    "emergencyContactName": "اسم جهة اتصال الطوارئ",
    "enterPhoneNumber": "أدخل رقم الهاتف",
    "yourPersonalPhoneNumber": "رقم هاتفك الشخصي",
    "yourPersonalEmail": "بريدك الإلكتروني الشخصي",
    "updatedSuccessfully": "تم التحديث بنجاح",
    "failedToUpdate": "فشل في التحديث",
    "noChangesMade": "لم يتم إجراء أي تغييرات",
    "isRequired": "مطلوب",
    "notifications": "الإشعارات",
    "noNotifications": "لا توجد إشعارات",
    "allCaughtUp": "لقد انتهيت من كل شيء!",
    "notification": "إشعار",
    "byName": "بواسطة {name}",
    "sent": "مرسل",
    "read": "مقروء",
    "justNow": "الآن",
    "dayAgo": "قبل {count} يوم",
    "daysAgo": "قبل {count} يوم",
    "hourAgo": "قبل {count} ساعة",
    "hoursAgo": "قبل {count} ساعة",
    "minuteAgo": "قبل {count} دقيقة",
    "minutesAgo": "قبل {count} دقيقة",
    "markAsRead": "تعيين كمقروء",
    "markAllAsRead": "تعيين الكل كمقروء",
    "notificationDetails": "تفاصيل الإشعار",
    "failedToLoadNotifications": "فشل تحميل الإشعارات",
    "noInternetConnectionNotifications": "لا يوجد اتصال بالإنترنت للإشعارات",
    "tapToMarkRead": "انقر لتعيين كمقروء",
    "unreadNotifications": "إشعارات غير مقروءة",
    "success": "نجاح",
    "updated": "تم التحديث",
    "privateTasks": "المهام الخاصة",
    "privateTasksDescription": "المهام غير المخصصة لأي مشروع",
    "messages": "الرسائل",
    "noMessages": "لا توجد رسائل",
    "messageHasError": "الرسالة تحتوي على خطأ",
    "attentionRequired": "يتطلب الاهتمام",
    "yesterday": "أمس",
    "messageDetails": "تفاصيل الرسالة",
    "subject": "الموضوع",
    "message": "الرسالة",
    "preview": "معاينة",
    "details": "التفاصيل",
    "record": "السجل",
    "messageSent": "تم إرسال الرسالة",
    "actionRequired": "إجراء مطلوب",
    "view": "عرض",
    "loadingAttachments": "جاري تحميل المرفقات...",
    "noAttachments": "لا توجد مرفقات",
    "unknownFile": "ملف غير معروف",
    "download": "تحميل",
    "open": "فتح",
    "opening": "جاري الفتح",
    "errorOpeningFile": "خطأ في فتح الملف",
    "image": "صورة",
    "autoRefreshOn": "التحديث التلقائي مفعل",
    "autoRefreshOff": "التحديث التلقائي معطل",
    "refreshingMessages": "جاري تحديث الرسائل...",
    "composeMessage": "كتابة رسالة",
    "replyToMessage": "الرد على الرسالة",
    "replyingTo": "جارٍ الرد على",
    "subjectHint": "أدخل الموضوع...",
    "messageHint": "اكتب رسالتك هنا...",
    "send": "إرسال",
    "subjectRequired": "الموضوع مطلوب",
    "messageRequired": "الرسالة مطلوبة",
    "noRecipients": "لا يوجد مستلمين",
    "recipients": "مستلمين",
    "messageSentSuccessfully": "تم إرسال الرسالة بنجاح",
    "deleteMessage": "حذف الرسالة",
    "areYouSureYouWantToDeleteThisMessage": "هل أنت متأكد أنك تريد حذف هذه الرسالة؟",
    "messageDeletedSuccessfully": "تم حذف الرسالة بنجاح",
    "uploadDocumentTitle": "تحميل مستند",
    "documentNameLabel": "اسم المستند",
    "urlLabel": "URL",
    "addUrlButton": "إضافة URL",
    "documentsUploadedSuccessfully": "تم تحميل المستندات بنجاح",
    "changePasswordTitle": "تغيير كلمة المرور",
    "currentPassword": "كلمة المرور الحالية",
    "currentPasswordHint": "أدخل كلمة المرور الحالية",
    "newPassword": "كلمة المرور الجديدة",
    "newPasswordHint": "أدخل كلمة المرور الجديدة",
    "confirmNewPassword": "تأكيد كلمة المرور الجديدة",
    "confirmNewPasswordHint": "أعد إدخال كلمة المرور الجديدة",
    "passwordChangedSuccess": "تم تغيير كلمة المرور بنجاح",
    "invalidCurrentPassword": "كلمة المرور الحالية غير صحيحة",
    "changePasswordFailed": "لم نتمكن من تغيير كلمة المرور. يُرجى المحاولة مرة أخرى.",
    "expiryWarning": "ينتهي اشتراكك بعد {daysRemaining} يوماً ({expiryDate}). يرجى التجديد قريباً.",
    "expiryUrgentWarning": "عاجل: ينتهي اشتراكك بعد {daysRemaining} يوماً ({expiryDate}). يرجى التجديد فوراً!",
    "subscriptionExpiredTitle": "انتهى الاشتراك",
    "subscriptionExpiredMessage": "لقد انتهى اشتراكك. يرجى التجديد لمواصلة استخدام التطبيق.",
    "subscriptionExpiredButton": "جدد الآن",
    "subscriptionExpiredContactSupport": "اتصل بالدعم",
    "subscriptionExpiredGoBackToLogin": "العودة إلى تسجيل الدخول",
    "thisWeek": "هذا الأسبوع",
    "listView": "عرض القائمة",
    "tableView": "عرض الجدول",
    "previousWeek": "الأسبوع السابق",
    "nextWeek": "الأسبوع التالي",
    "thisMonth": "هذا الشهر",
    "previousMonth": "الشهر السابق",
    "nextMonth": "الشهر التالي",
    "weekView": "أسبوع",
    "monthView": "شهر",
    "projectTask": "المشروع / المهمة",
    "mon": "اثنين",
    "tue": "ثلاثاء",
    "wed": "أربعاء",
    "thu": "خميس",
    "fri": "جمعة",
    "sat": "سبت",
    "sun": "أحد"
  },
  "de": {
    "language": "Deutsch",
    "getStarted": "Loslegen",
    "hello": "Hallo {name}",
    "onboardingPageOneTitle": "Willkommen bei Crew Core",
    "onboardingPageTwoTitle": "Ihre Reise beginnt hier",
    "onboardingPageThreeTitle": "Legen wir los!",
    "onboardingBottomSheetTitle": "Einfach Ihre Teilnahme bestätigen",
    "onboardingBottomSheetSubtitle": "Es ist allgemein bekannt, dass der Leser durch lesbaren Inhalt abgelenkt wird.",
    "next": "Weiter",
    "needHelp": "Brauchen Sie Hilfe?",
    "welcomeBack": "Willkommen zurück!",
    "to": "bei",
    "loginPageSubtitle": "Willkommen, bitte melden Sie sich an, um fortzufahren",
    "email": "E-Mail",
    "emailHint": "Geben Sie Ihre E-Mail-Adresse ein",
    "password": "Passwort",
    "passwordHint": "Geben Sie Ihr Passwort ein",
    "forgotPassword": "Passwort vergessen?",
    "doNotHaveAnAccount": "Sie haben noch kein Konto? ",
    "haveAnAccount": "Sie haben bereits ein Konto? ",
    "register": "Registrieren",
    "orContinueWith": "ODER weiter mit",
    "login": "Anmelden",
    "firstName": "Vorname",
    "firstNameHint": "Geben Sie Ihren Vornamen ein",
    "lastName": "Nachname",
    "lastNameHint": "Geben Sie Ihren Nachnamen ein",
    "confirmPassword": "Passwort bestätigen",
    "confirmPasswordHint": "Geben Sie Ihr Passwort erneut ein",
    "iAgreeToThe": "Ich stimme den ",
    "termsAndConditions": "Allgemeinen Geschäftsbedingungen zu",
    "requiredField": "Dieses Feld ist erforderlich.",
    "invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "passwordTooShort": "Das Passwort muss mindestens 6 Zeichen lang sein.",
    "passwordsDoNotMatch": "Passwörter stimmen nicht überein",
    "acceptTermsMessage": "Sie müssen den Allgemeinen Geschäftsbedingungen zustimmen, um fortzufahren.",
    "forgot_password": "Passwort vergessen",
    "provide_mail": "Bitte geben Sie uns Ihre E-Mail-Adresse",
    "doNot_worry": "Keine Sorge",
    "send_email": "E-Mail senden",
    "termsAndConditionsText": "Willkommen in unserer Anwendung. Durch den Zugriff auf diese App oder deren Nutzung erklären Sie sich mit den folgenden Allgemeinen Geschäftsbedingungen einverstanden.\n\n1. Annahme der Bedingungen\nDurch das Erstellen eines Kontos oder die Nutzung unserer Dienste stimmen Sie diesen Bedingungen und unserer Datenschutzrichtlinie zu.\n\n2. Pflichten der Benutzer\n- Sie müssen mindestens 13 Jahre alt sein, um die App zu nutzen.\n- Sie sind verantwortlich für die Vertraulichkeit Ihres Kontos.\n- Sie müssen genaue, aktuelle und vollständige Informationen bereitstellen.\n\n3. Nutzungsbeschränkungen\nSie verpflichten sich, Folgendes zu unterlassen:\n- Die App für illegale oder nicht autorisierte Zwecke zu verwenden.\n- Den Betrieb der App zu stören.\n- Sich unbefugten Zugriff zu verschaffen.\n\n4. Geistiges Eigentum\nAlle Inhalte und Daten sind geistiges Eigentum des App-Betreibers und dürfen nicht ohne Genehmigung verwendet werden.\n\n5. Kündigung\nWir können Ihren Zugriff ohne Vorankündigung sperren oder beenden, wenn Sie gegen diese Bedingungen verstoßen.\n\n6. Haftungsausschluss\nDiese App wird „wie besehen“ ohne jegliche Gewährleistungen bereitgestellt.\n\n7. Änderungen der Bedingungen\nWir können diese Bedingungen jederzeit aktualisieren. Die fortgesetzte Nutzung gilt als Zustimmung zu den Änderungen.\n\n8. Kontakt\nBei Fragen wenden Sie sich bitte an support@example.com",
    "noInternetMessage": "Keine Internetverbindung. Bitte überprüfen Sie Ihre Verbindung.",
    "unknownError": "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    "invalidEmailOrPassword": "Ungültige E-Mail-Adresse oder Passwort",
    "wrongPassword": "Ungültiges Passwort. Bitte überprüfen Sie Ihr Passwort.",
    "userNotFound": "Benutzer nicht gefunden. Bitte überprüfen Sie Ihre Anmeldedaten.",
    "companyNotFound": "Unternehmen nicht gefunden. Bitte prüfen Sie den Firmennamen.",
    "invalidToken": "Ungültiges Sitzungstoken. Bitte melden Sie sich erneut an.",
    "genericLoginError": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    "congratulations": "Herzlichen Glückwunsch",
    "yourAccountIsReadyToUse": "Dein Konto ist einsatzbereit!",
    "resetEmailSent": "Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.",
    "enableBiometrics": "Biometrische Anmeldung aktivieren?",
    "enableBiometricsDescription": "Möchten Sie sich beim nächsten Mal schneller mit Fingerabdruck oder Gesichtserkennung anmelden?",
    "loginWithBiometrics": "Mit Biometrie anmelden",
    "yes": "Ja",
    "no": "Nein",
    "biometricsNotFound": "Biometrische Daten nicht gefunden! Bitte melden Sie sich erneut an",
    "resetPasswordTitle": "Passwort zurücksetzen?",
    "resetPasswordWarning": "Wenn du dein Passwort zurücksetzt, wird der biometrische Login deaktiviert. Du musst dich erneut anmelden und ihn wieder aktivieren.",
    "cancel": "Abbrechen",
    "continueText": "Fortfahren",
    "googleSignInFailed": "Die Google-Anmeldung wurde abgebrochen oder ist fehlgeschlagen",
    "myWorkSummary": "Meine Arbeitszusammenfassung",
    "myWorkSummarySubtitle": "Heutige Aufgaben & Anwesenheitsaktivität",
    "todaysAttendance": "Anwesenheit heute",
    "totalWorkingHours": "Gesamtarbeitsstunden",
    "today": "Heute",
    "breaksToday": "Pausen heute",
    "clockIn": "Arbeitsbeginn",
    "backToWork": "Zurück zur Arbeit",
    "takeABreak": "Pause machen",
    "clockOut": "Arbeitsende",
    "hoursLabel": "{hours}:{minutes} Std.",
    "paidPeriod": "Abrechnungszeitraum {start} – {end}",
    "period": "Abrechnungszeitraum {start} – {end}",
    "clockInAreaTitle": "Sie befinden sich im Ein‑Stempel‑Bereich!",
    "clockInAreaDescription": "Jetzt können Sie hier auf Ein‑Stempel drücken",
    "notInClockInAreaTitle": "Sie befinden sich außerhalb des Eincheckbereichs!",
    "notInClockOutAreaTitle": "Sie befinden sich außerhalb des Abmeldebereichs!",
    "notInClockInAreaDescription": "Sie können sich in diesem Bereich nicht einchecken",
    "myProfileSection": "MEIN PROFIL",
    "scheduleSection": "TERMINPLAN",
    "clockInAreaLabel": "Ein‑Stempel‑Bereich",
    "fetchingLocation": "Standort wird ermittelt…",
    "error": "Fehler",
    "yourActivity": "Ihre Aktivität",
    "activity": "Aktivität",
    "onTime": "Pünktlich",
    "viewAll": "Alle anzeigen",
    "confirmClockOutTitle": "Ausloggen bestätigen",
    "confirmClockOutMessage": "Sobald Sie sich ausloggen, können Sie diese Zeit nicht mehr bearbeiten. Bitte überprüfen Sie Ihre Stunden sorgfältig, bevor Sie fortfahren.",
    "noLetMeCheck": "Nein, ich möchte nochmal prüfen",
    "thisPayPeriod": "Dieser Abrechnungszeitraum",
    "locationUnavailable": "Standort nicht verfügbar",
    "locationUnavailableMessage": "Ihr Standort kann derzeit nicht ermittelt werden. Bitte stellen Sie sicher, dass die Standortdienste aktiviert sind.",
    "noInternetActionSaved": "Keine Internetverbindung. Deine Ein‑/Aus‑Stempelung wurde lokal gespeichert und wird synchronisiert, sobald du wieder online bist.",
    "manager": "Manager",
    "client": "Kunde",
    "tasks": "Aufgaben",
    "projects": "Projekte",
    "projectsSubtitle": "Die Projekte, denen Sie zugewiesen sind",
    "tasksSubtitle": "Die dir zugewiesenen Aufgaben",
    "home": "Startseite",
    "attendance": "Anwesenheit",
    "more": "Mehr",
    "pleaseWaitOneMinute": "Bitte warte mindestens 1 Minute zwischen den Aktionen.",
    "leaveSummary": "Urlaubsübersicht",
    "available": "Verfügbar",
    "leaveUsed": "Genommener Urlaub",
    "review": "In Prüfung",
    "approved": "Genehmigt",
    "rejected": "Abgelehnt",
    "leaveDate": "Urlaubsdatum",
    "approvedAt": "Genehmigt am",
    "rejectedAt": "Abgelehnt am",
    "expenseSummary": "Ausgabenübersicht",
    "claimYourExpensesHere": "Reichen Sie hier Ihre Ausgaben ein.",
    "totalExpense": "Gesamtausgaben",
    "totalLeave": "Gesamter Urlaub",
    "total": "Gesamt",
    "type": "Typ",
    "allApprovals": "Alle Genehmigungen",
    "totalApprovals": "Gesamte Genehmigungen",
    "noLeaveSubmitted": "Kein Urlaub eingereicht!",
    "noLeaveApproved": "Kein Urlaub genehmigt!",
    "noLeaveRejected": "Kein Urlaub abgelehnt!",
    "noLeaveSubmittedSubtitle": "Bereit für eine Pause? Klicken Sie auf „Urlaub einreichen“ und gönnen Sie sich eine wohlverdiente Auszeit!",
    "noExpenseSubmitted": "Keine Ausgaben eingereicht!",
    "noExpenseApproved": "Keine Ausgaben genehmigt!",
    "noExpenseRejected": "Keine Ausgaben abgelehnt!",
    "noExpenseSubtitle": "Es sieht so aus, als hätten Sie noch keine Ausgaben. Keine Sorge – dieser Bereich wird aktualisiert, sobald neue Daten verfügbar sind.",
    "noApprovalSubmitted": "Keine Genehmigungen eingereicht!",
    "noApprovalApproved": "Keine Genehmigungen genehmigt!",
    "noApprovalRejected": "Keine Genehmigungen abgelehnt!",
    "noApprovalSubtitle": "Sie haben derzeit keine Genehmigungen. Keine Sorge – dieser Bereich wird aktualisiert, sobald neue Daten vorliegen.",
    "leaveSubmitted": "Eingereichte Urlaube",
    "leaveInformation": "Urlaubsdetails",
    "expensesSubmitted": "Eingereichte Ausgaben",
    "expensesInformation": "Ausgabendetails",
    "approvalSubmitted": "Eingereichte Genehmigungen",
    "approvalInformation": "Genehmigungsdetails",
    "pleaseSelectLeaveCategory": "Bitte wählen Sie eine Urlaubsart aus",
    "pleaseSelectLeaveDuration": "Bitte wählen Sie die Urlaubsdauer aus",
    "pleaseSelectTaskDelegation": "Bitte wählen Sie eine Aufgabenübertragung aus",
    "submitLeave": "Urlaub einreichen",
    "submitLeaveMessage": "Überprüfen Sie Ihre Urlaubsdetails, um sicherzustellen, dass alles korrekt ist. Möchten Sie fortfahren?",
    "submitMessage": "um sicherzustellen, dass alles korrekt ist. Möchten Sie fortfahren?",
    "submitText": "Ja, einreichen",
    "fillLeaveInformation": "Urlaubsinformationen ausfüllen",
    "informationAboutLeaveDetails": "Informationen zu den Urlaubsdaten",
    "leaveCategory": "Urlaubskategorie",
    "selectLeaveCategory": "Urlaubskategorie auswählen",
    "leaveDuration": "Urlaubsdauer",
    "selectDuration": "Dauer auswählen",
    "taskDelegation": "Aufgabenübertragung",
    "selectTaskDelegation": "Aufgabenübertragung auswählen",
    "emergencyContactDuringLeavePeriod": "Notfallkontakt während der Urlaubszeit",
    "pleaseEnterContactNumber": "Bitte geben Sie eine Telefonnummer ein",
    "numberTooShort": "Nummer zu kurz",
    "leaveDescription": "Urlaubsbeschreibung",
    "enterLeaveDescription": "Urlaubsbeschreibung eingeben",
    "pleaseEnterDescription": "Bitte geben Sie eine Beschreibung ein",
    "selectCategory": "Kategorie auswählen",
    "leaveRequest": "Urlaubsantrag",
    "expenseRequest": "Spesenantrag",
    "approvalRequest": "Genehmigungsantrag",
    "leavesApproved": "Genehmigte Urlaube",
    "leavesRejected": "Abgelehnte Urlaube",
    "expensesApproved": "Genehmigte Ausgaben",
    "expensesRejected": "Abgelehnte Ausgaben",
    "approvalsApproved": "Genehmigte Anträge",
    "approvalsRejected": "Abgelehnte Anträge",
    "submitExpense": "Ausgabe einreichen",
    "fillClaimInformation": "Angaben zur Forderung ausfüllen",
    "informationAboutClaimDetails": "Informationen zu den Anspruchsdetails",
    "expenseCategory": "Ausgabenkategorie",
    "selectExpenseCategory": "Ausgabenkategorie auswählen",
    "paidBy": "Bezahlt von",
    "selectEmployeeOrCompany": "Mitarbeiter oder Unternehmen auswählen",
    "expenseDate": "Ausgabedatum",
    "enterTransactionDate": "Transaktionsdatum eingeben",
    "expenseAmount": "Ausgabenbetrag",
    "expenseDescription": "Ausgabenbeschreibung",
    "enterExpenseDescription": "Ausgabenbeschreibung eingeben",
    "uploadClaimDocument": "Dokument hochladen",
    "selectApprovalCategory": "Genehmigungskategorie auswählen",
    "enterDate": "Datum eingeben",
    "enterPeriod": "Zeitraum eingeben",
    "submitApproval": "Genehmigung einreichen",
    "fillApprovalInformation": "Genehmigungsinformationen ausfüllen",
    "informationAboutApprovalDetails": "Informationen zu den Genehmigungsdetails",
    "approvalCategory": "Genehmigungskategorie",
    "requestOwner": "Antragsteller",
    "location": "Standort",
    "pleaseEnterLocation": "Bitte Standort eingeben",
    "date": "Datum",
    "periodd": "Zeitraum",
    "reference": "Referenz",
    "pleaseEnterReference": "Bitte Referenz eingeben",
    "contact": "Kontakt",
    "pleaseEnterContact": "Bitte Kontakt eingeben",
    "uploadFile": "Datei hochladen",
    "approvalDescription": "Genehmigungsbeschreibung",
    "enterApprovalDescription": "Genehmigungsbeschreibung eingeben",
    "quantity": "Menge",
    "enterQuantity": "Menge eingeben",
    "pleaseEnterQuantity": "Bitte geben Sie eine gültige Menge ein",
    "quantityMustBePositiveNumber": "Die Menge muss eine positive Zahl sein",
    "product": "Produkt",
    "addProduct": "Produkt hinzufügen",
    "productName": "Produktname",
    "description": "Beschreibung",
    "close": "Schließen",
    "add": "Hinzufügen",
    "requests": "Anfragen",
    "title": "Titel",
    "pleaseEnterTitle": "Bitte geben Sie einen Titel ein",
    "errorLoadingCategories": "Fehler beim Laden der Kategorien.",
    "noCategoriesAvailable": "Keine Kategorien verfügbar.",
    "amount": "Betrag",
    "enterAmount": "Betrag eingeben",
    "errorLoadingContacts": "Fehler beim Laden der Kontakte",
    "name": "Name",
    "enterName": "Name eingeben",
    "pleaseEnterName": "Bitte geben Sie einen Namen ein.",
    "enterValidAmount": "Bitte geben Sie einen gültigen Betrag ein.",
    "account": "Konto",
    "selectAccount": "Konto auswählen",
    "selectExpenseAccount": "Ausgabenkonto auswählen",
    "vendor": "Lieferant",
    "selectVendor": "Lieferant auswählen",
    "selectExpenseVendor": "Ausgabelieferant auswählen",
    "saleOrder": "Verkaufsauftrag",
    "selectSaleOrder": "Verkaufsauftrag auswählen",
    "selectExpenseSaleOrder": "Ausgabeverkaufsauftrag auswählen",
    "submitNow": "Jetzt absenden",
    "currency": "Währung",
    "selectCurrency": "Währung auswählen",
    "selectExpenseCurrency": "Ausgabewährung auswählen",
    "customerToReinvoice": "Kunde zur erneuten Rechnungsstellung",
    "selectCustomerToReinvoice": "Kunden zur erneuten Rechnungsstellung auswählen",
    "pleaseEnterStartDate": "Bitte geben Sie ein Startdatum ein.",
    "pleaseEnterEndDate": "Bitte geben Sie ein Enddatum ein.",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "pleaseEnterStartTime": "Bitte geben Sie eine Startzeit ein.",
    "pleaseEnterEndTime": "Bitte geben Sie eine Endzeit ein.",
    "startTime": "Startzeit",
    "endTime": "Endzeit",
    "pleaseSelectDayPart": "Bitte wählen Sie einen Tagesabschnitt.",
    "hourBasedLeave": "Stundenbasierter Urlaub",
    "halfDayLeave": "Halbtägiger Urlaub",
    "selectStartTime": "Startzeit auswählen",
    "selectEndTime": "Endzeit auswählen",
    "selectDayPart": "Tagesabschnitt auswählen",
    "dayPart": "Tagesabschnitt",
    "categoryLeaveDaysExceeded": "Die Gesamtanzahl der Urlaubstage überschreitet das zulässige Limit für diese Kategorie.",
    "allowedDays": "Erlaubte Tage:",
    "allowedHours": "Erlaubte Stunden:",
    "endTimeMustBeAfterStartTime": "Die Enduhrzeit muss nach der Startuhrzeit liegen",
    "categoryLeaveBalanceExceeded": "Die beantragte Freistellung übersteigt Ihr verfügbares Guthaben",
    "hr": "Personalabteilung",
    "employees": "Mitarbeiter",
    "viewAndEditYourEmployeesData": "Anzeigen und Bearbeiten Sie Ihre Mitarbeiterdaten",
    "employeesInformation": "Mitarbeiterinformationen",
    "noName": "Kein Name",
    "noEmail": "Keine E-Mail",
    "noPhone": "Kein Telefon",
    "noType": "Kein Typ",
    "pleaseEnter": "Bitte eingeben",
    "addNewTeamMember": "Neues Teammitglied hinzufügen",
    "fillInTheDetailsToCreateANewEmployeeProfile": "Füllen Sie die Details aus, um ein neues Mitarbeiterprofil zu erstellen",
    "changesSavedSuccessfully": "Änderungen erfolgreich gespeichert!",
    "editModeEnabled": "Bearbeitungsmodus aktiviert",
    "confirmDelete": "Löschen bestätigen",
    "areYouSureYouWantToDeleteThisEmployee": "Sind Sie sicher, dass Sie diesen Mitarbeiter löschen möchten?",
    "thisActionCannotBeUndone": "Diese Aktion kann nicht rückgängig gemacht werden",
    "delete": "Löschen",
    "employeeDeletedSuccessfully": "Mitarbeiter erfolgreich gelöscht",
    "addLocation": "Standort hinzufügen",
    "locationName": "Standortname",
    "address": "Adresse",
    "locationAddedSuccessfully": "Standort erfolgreich hinzugefügt",
    "employeeDetails": "Mitarbeiterdetails",
    "employeeInformation": "Mitarbeiterinformationen",
    "fullName": "Vollständiger Name",
    "workEmail": "Geschäfts-E-Mail",
    "workPhone": "Geschäftstelefon",
    "employeeType": "Mitarbeitertyp",
    "departmentID": "Abteilungs-ID",
    "companyInformation": "Firmeninformationen",
    "company": "Firma",
    "notSpecified": "Nicht angegeben",
    "categories": "Kategorien",
    "none": "Keine",
    "assignedLocations": "Zugewiesene Standorte",
    "noLocationsAssigned": "Keine Standorte zugewiesen",
    "saveChanges": "Änderungen speichern",
    "employeeAlreadyExists": "Mitarbeiter existiert bereits",
    "createNewEmployee": "Neuen Mitarbeiter erstellen",
    "employeeName": "Mitarbeitername",
    "enterFullName": "Vollständigen Namen eingeben",
    "pleaseEnterEmployeeName": "Bitte geben Sie den Mitarbeiternamen ein",
    "enterWorkEmail": "Geschäfts-E-Mail eingeben",
    "pleaseEnterEmailAddress": "Bitte geben Sie die E-Mail-Adresse ein",
    "pleaseEnterAValidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "createEmployee": "Mitarbeiter erstellen",
    "byCreatingThisProfileYouAgreeToOurTermsOfService": "Durch das Erstellen dieses Profils stimmen Sie unseren Nutzungsbedingungen zu",
    "employeeCreatedSuccessfully": "Mitarbeiter erfolgreich erstellt!",
    "hasBeenAddedToYourTeam": "wurde Ihrem Team hinzugefügt",
    "backToEmployees": "Zurück zu Mitarbeitern",
    "deadline": "Frist",
    "progress": "Fortschritt",
    "status": "Status",
    "assignees": "Zugewiesene",
    "timesheets": "Stundenzettel",
    "taskId": "Aufgaben-ID",
    "project": "Projekt",
    "task": "Aufgabe",
    "selectTask": "Aufgabe auswählen",
    "allProjects": "Alle Projekte",
    "allTasks": "Alle Aufgaben",
    "addTimesheet": "Stundenzettel hinzufügen",
    "quickAdd": "Schnell hinzufügen",
    "loading": "Wird geladen...",
    "timesheetAddedSuccessfully": "Stundenzettel erfolgreich hinzugefügt",
    "noTimesheetRecordsYet": "Noch keine Stundenzettel-Einträge",
    "enterDescription": "Beschreibung eingeben",
    "timesheetDeletedSuccessfully": "Stundenzettel erfolgreich gelöscht",
    "edit": "Bearbeiten",
    "editTimesheet": "Stundenzettel bearbeiten",
    "currentSession": "Aktuelle Sitzung",
    "locationDisabled": "Standort deaktiviert",
    "enableLocationMessage": "Um standortbasiertes Ein- und Ausstempeln zu nutzen, aktivieren Sie bitte die Standortdienste in Ihren Geräteeinstellungen.",
    "settings": "Einstellungen",
    "microphonePermissionNotGranted": "Mikrofonberechtigung nicht erteilt",
    "microphoneAccessNeeded": "Mikrofonzugriff erforderlich",
    "thisAppNeedsMicrophoneAccessToRecordVoiceNotesForYourTimesheets": "Diese App benötigt Mikrofonzugriff, um Sprachnotizen für deine Stundenzettel aufzunehmen.",
    "deny": "Ablehnen",
    "allow": "Zulassen",
    "microphonePermissionIsRequiredToRecordAudio": "Mikrofonberechtigung ist erforderlich, um Audio aufzunehmen",
    "failedToPlayRecording": "Wiedergabe der Aufnahme fehlgeschlagen",
    "voiceNote": "Sprachnotiz",
    "recording": "Aufnahme",
    "duration": "Dauer",
    "stopRecording": "Aufnahme stoppen",
    "recordNow": "Jetzt aufnehmen",
    "reportDeleted": "Der Bericht wurde erfolgreich gelöscht",
    "draft": "Entwurf",
    "reportUpdated": "Der Bericht wurde erfolgreich aktualisiert",
    "rememberMe": "Angemeldet bleiben",
    "loggingInTo": "Anmeldung bei",
    "yourLastOrganization": "Ihrer letzten Organisation",
    "clockingOutFrom": "Abmeldung von",
    "clockingOut": "Abmeldung",
    "clockingInFrom": "Anmeldung von",
    "clockingIn": "Anmeldung",
    "youCanPressClockIn": "Sie können auf 'Anmelden' drücken",
    "youCanPressClockOut": "Sie können auf 'Abmelden' drücken",
    "thereWasNoChangesApplied": "Es wurden keine Änderungen vorgenommen",
    "fromTo": "Von - Bis",
    "time": "Zeit",
    "by": "Von",
    "requestDetails": "Anfragedetails",
    "products": "Produkte",
    "approval": "Genehmigung",
    "recordOn": "Aufgezeichnet am",
    "category": "Kategorie",
    "lastUpdatedOn": "Zuletzt aktualisiert am",
    "dateSet": "Datum festgelegt",
    "contactName": "Kontaktname",
    "contactEmail": "Kontakt-E-Mail",
    "attachments": "Anhänge",
    "couldNotOpenLink": "Link konnte nicht geöffnet werden",
    "approversInformation": "Genehmigerinformationen",
    "unknown": "Unbekannt",
    "errorLoadingProducts": "Fehler beim Laden der Produkte",
    "noProductsAvailable": "Keine Produkte verfügbar",
    "noExpensesInDraft": "Keine Entwürfe vorhanden",
    "expenseDetails": "Ausgabendetails",
    "nameUnset": "Name nicht festgelegt",
    "totalAmount": "Gesamtbetrag",
    "employee": "Mitarbeiter",
    "companyCurrency": "Unternehmenswährung",
    "currencyRate": "Wechselkurs",
    "approvedBy": "Genehmigt von",
    "approvedOn": "Genehmigt am",
    "taxes": "Steuern",
    "areYouSureYouWantToDeleteThisExpense": "Sind Sie sicher, dass Sie diese Ausgabe löschen möchten?",
    "areYouSureYouWantToDeleteThisReport": "Sind Sie sicher, dass Sie diesen Bericht löschen möchten?",
    "currencyNotFound": "Währung nicht gefunden",
    "notFound": "Nicht gefunden",
    "errorSelectingCurrency": "Fehler bei der Währungsauswahl",
    "unnamedCurrency": "Unbenannte Währung",
    "noCurrencySelected": "Keine Währung ausgewählt",
    "errorLoadingCurrencies": "Fehler beim Laden der Währungen",
    "noCurrenciesAvailable": "Keine Währungen verfügbar",
    "unnamedAccount": "Unbenanntes Konto",
    "errorLoadingAccounts": "Fehler beim Laden der Konten",
    "noAccountsAvailable": "Keine Konten verfügbar",
    "categoryNotFound": "Kategorie nicht gefunden",
    "errorSelectingCategory": "Fehler bei der Kategorieauswahl",
    "unnamedCategory": "Unbenannte Kategorie",
    "editExpense": "Ausgabe bearbeiten",
    "editing": "Bearbeitung",
    "update": "Aktualisieren",
    "errorLoadingProjects": "Fehler beim Laden der Projekte",
    "addProjects": "Projekte hinzufügen",
    "allProjectsSelected": "Alle Projekte ausgewählt",
    "noProjectsAvailable": "Keine Projekte verfügbar",
    "unnamedSaleOrder": "Unbenannter Verkaufsauftrag",
    "errorLoadingSaleOrders": "Fehler beim Laden der Verkaufsaufträge",
    "noSaleOrdersAvailable": "Keine Verkaufsaufträge verfügbar",
    "vendorNotFound": "Lieferant nicht gefunden",
    "errorSelectingVendor": "Fehler bei der Lieferantenauswahl",
    "unnamedVendor": "Unbenannter Lieferant",
    "noVendorSelected": "Kein Lieferant ausgewählt",
    "errorLoadingVendors": "Fehler beim Laden der Lieferanten",
    "noVendorsAvailable": "Keine Lieferanten verfügbar",
    "areYouSureYouWantToDeleteThisLeave": "Sind Sie sicher, dass Sie diesen Urlaub löschen möchten?",
    "leaveIsDeletedSuccessfully": "Urlaub erfolgreich gelöscht",
    "leaveDetails": "Urlaubsdetails",
    "leaveNotFound": "Urlaub nicht gefunden",
    "dateFrom": "Von Datum",
    "dateTo": "Bis Datum",
    "numberOfDays": "Anzahl der Tage",
    "numberOfHours": "Anzahl der Stunden",
    "hourFrom": "Von Stunde",
    "hourTo": "Bis Stunde",
    "approver": "Genehmiger",
    "leaveUpdatedSuccessfully": "Urlaub erfolgreich aktualisiert",
    "leaveSubmittedSuccessfully": "Urlaub erfolgreich eingereicht",
    "updateLeave": "Urlaub aktualisieren",
    "yesUpdate": "Ja, aktualisieren",
    "selectDayPartSubtitle": "Tagesabschnitt auswählen",
    "search": "Suche",
    "untitledTask": "Unbenannte Aufgabe",
    "noTasksAssignedYet": "Keine Aufgaben zugewiesen",
    "updateTimeSheet": "Stundenzettel aktualisieren",
    "addTimeSheet": "Stundenzettel hinzufügen",
    "enterTime": "Zeit eingeben",
    "timeAddedSuccessfully": "Zeit erfolgreich hinzugefügt",
    "attachment": "Anhang",
    "items": "Artikel",
    "logout": "Abmelden",
    "changeLanguage": "Sprache ändern",
    "selectYourPreferredLanguage": "Wählen Sie Ihre bevorzugte Sprache aus",
    "taskStage": "Aufgabenphase",
    "noStage": "Keine Phase",
    "updating": "Wird aktualisiert...",
    "errorLoadingStages": "Fehler beim Laden der Phasen",
    "loadingStages": "Phasen werden geladen...",
    "stageUpdatedTo": "Phase aktualisiert auf",
    "failedToUpdateStage": "Phase konnte nicht aktualisiert werden",
    "selected": "Ausgewählt",
    "noStagesAvailable": "Keine Phasen verfügbar",
    "current": "Aktuell",
    "updatingStage": "Phase wird aktualisiert...",
    "reasonOfRejection": "Grund der Ablehnung",
    "documents": "Dokumente",
    "noDocuments": "Keine Dokumente gefunden",
    "documentDetails": "Dokumentendetails",
    "createDocument": "Dokument erstellen",
    "editDocument": "Dokument bearbeiten",
    "deleteDocument": "Dokument löschen",
    "deleteDocumentConfirmation": "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
    "documentType": "Dokumenttyp",
    "issueDate": "Ausstellungsdatum",
    "expiryDate": "Ablaufdatum",
    "systemInformation": "Systeminformationen",
    "createdBy": "Erstellt von",
    "createdOn": "Erstellt am",
    "lastUpdatedBy": "Zuletzt aktualisiert von",
    "notificationDays": "Benachrichtigungstage",
    "notificationType": "Benachrichtigungstyp",
    "active": "Aktiv",
    "expired": "Abgelaufen",
    "expiringSoon": "Läuft bald ab",
    "valid": "Gültig",
    "noExpiry": "Kein Ablauf",
    "expiredDocuments": "Abgelaufene Dokumente",
    "expiringDocuments": "Läuft bald ab",
    "save": "Speichern",
    "failedToFetchDocuments": "Dokumente konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "failedToCreateDocument": "Dokument konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    "failedToUpdateDocument": "Dokument konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    "failedToDeleteDocument": "Dokument konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    "documentCreatedSuccessfully": "Dokument erfolgreich erstellt",
    "documentUpdatedSuccessfully": "Dokument erfolgreich aktualisiert",
    "documentDeletedSuccessfully": "Dokument erfolgreich gelöscht",
    "noDocumentSelected": "Kein Dokument ausgewählt",
    "invalidDocumentData": "Ungültige Dokumentendaten. Bitte überprüfen Sie die erforderlichen Felder.",
    "sessionExpired": "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    "accessDenied": "Zugriff verweigert. Sie haben keine Berechtigung für diese Aktion.",
    "networkError": "Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung.",
    "pleaseEnterDocumentName": "Bitte geben Sie einen Dokumentnamen ein",
    "pleaseSelectDocumentType": "Bitte wählen Sie einen Dokumenttyp aus",
    "pleaseSelectEmployee": "Bitte wählen Sie einen Mitarbeiter aus",
    "invalidDate": "Ungültiges Datumsformat",
    "expiryDateBeforeIssueDate": "Ablaufdatum darf nicht vor dem Ausstellungsdatum liegen",
    "documentNameRequired": "Dokumentname ist erforderlich",
    "documentTypeRequired": "Dokumenttyp ist erforderlich",
    "documentName": "Dokumentname",
    "selectDocumentType": "Dokumenttyp auswählen",
    "loadingDocumentTypes": "Lade Dokumenttypen...",
    "errorLoadingDocumentTypes": "Fehler beim Laden der Dokumenttypen",
    "noDocumentTypesAvailable": "Keine Dokumenttypen verfügbar",
    "documentNumber": "Dokumentnummer",
    "overdue": "Überfällig",
    "created": "Erstellt",
    "payslips": "Gehaltsabrechnungen",
    "viewYourSalarySlips": "Ihre Gehaltsabrechnungen anzeigen",
    "noPayslips": "Keine Gehaltsabrechnungen verfügbar",
    "payslipDetails": "Gehaltsabrechnungsdetails",
    "noPayslipDetails": "Keine Gehaltsabrechnungsdetails verfügbar",
    "pending": "Ausstehend",
    "paid": "Bezahlt",
    "earnings": "Verdienste",
    "deductions": "Abzüge",
    "other": "Andere",
    "pendingPayslips": "Ausstehende Gehaltsabrechnungen",
    "cancelled": "Storniert",
    "unnamedPayslip": "Unbenannte Gehaltsabrechnung",
    "noNumber": "Keine Nummer",
    "basicWage": "Grundlohn",
    "grossWage": "Bruttolohn",
    "netWage": "Nettolohn",
    "from": "Von",
    "unnamedItem": "Unbenannter Artikel",
    "done": "Erledigt",
    "salaryComputation": "Gehaltsberechnung",
    "workedDays": "Arbeitstage",
    "otherInfo": "Weitere Informationen",
    "workedDaysDescription": "Detaillierte Aufschlüsselung der Arbeitstage, Überstunden und Feiertage",
    "otherInfoDescription": "Zusätzliche Gehaltsabrechnungsinformationen und Details",
    "payslipNumber": "Gehaltsabrechnungsnummer",
    "contract": "Vertrag",
    "payStructure": "Vergütungsstruktur",
    "errorLoadingWorkedDays": "Fehler beim Laden der Arbeitstage",
    "retry": "Wiederholen",
    "noWorkedDays": "Keine Arbeitstagsdaten",
    "noWorkedDaysDescription": "Keine Arbeitstagsinformationen für diesen Gehaltsabrechnungszeitraum verfügbar",
    "workedDaysSummary": "Arbeitstage Zusammenfassung",
    "totalDays": "Gesamttage",
    "totalHours": "Gesamtstunden",
    "days": "Tage",
    "hours": "Stunden",
    "minutes": "Minuten",
    "unpaid": "Unbezahlt",
    "creditTime": "Guthabenzeit",
    "searchProjectsHint": "Nach Projektname oder Kunde suchen...",
    "noProjectsFound": "Keine Projekte gefunden",
    "tryDifferentKeywords": "Versuchen Sie andere Suchbegriffe",
    "searchTasksHint": "Nach Aufgabenname suchen...",
    "noTasksFound": "Keine Aufgaben gefunden",
    "showing": "Anzeigen",
    "clearFilter": "Filter löschen",
    "allStages": "Alle Phasen",
    "filterByStage": "Nach Phase filtern",
    "all": "Alle",
    "noDocumentsFound": "Keine Dokumente gefunden",
    "searchDocumentsHint": "Dokumente suchen (Name, Typ, Beschreibung)...",
    "userProfile": "Benutzerprofil",
    "contactInformation": "Kontaktinformationen",
    "jobInformation": "Jobinformationen",
    "timeAttendance": "Zeit & Anwesenheit",
    "emergencyContact": "Notfallkontakt",
    "noProfileData": "Keine Profildaten verfügbar",
    "mobile": "Mobil",
    "personalEmail": "Persönliche E-Mail",
    "personalPhone": "Privattelefon",
    "notProvided": "Nicht angegeben",
    "department": "Abteilung",
    "jobPosition": "Position",
    "coach": "Coach",
    "workLocation": "Arbeitsort",
    "workSchedule": "Arbeitszeitplan",
    "hourlyCost": "Stundenkosten",
    "checkedIn": "Eingecheckt",
    "checkedOut": "Ausgecheckt",
    "absent": "Abwesend",
    "lastMonth": "Letzter Monat",
    "totalOvertime": "Gesamt Überstunden",
    "lastCheckIn": "Letzter Check-in",
    "lastCheckOut": "Letzter Check-out",
    "remaining": "Verbleibend",
    "totalAllocated": "Gesamt zugeteilt",
    "used": "Verwendet",
    "currentLeave": "Aktueller Urlaub",
    "emergencyPhone": "Notfalltelefon",
    "additionalContactInformation": "Zusätzliche Kontaktinformationen",
    "privatePhone": "Privates Telefon",
    "privateEmail": "Private E-Mail",
    "noEmergencyContactSet": "Kein Notfallkontakt festgelegt",
    "pleaseUpdateEmergencyContact": "Bitte aktualisieren Sie Ihre Notfallkontaktinformationen",
    "addEmergencyContact": "Notfallkontakt hinzufügen",
    "editEmergencyContacts": "Notfallkontakte bearbeiten",
    "emergencyContactName": "Name des Notfallkontakts",
    "enterPhoneNumber": "Telefonnummer eingeben",
    "yourPersonalPhoneNumber": "Ihre persönliche Telefonnummer",
    "yourPersonalEmail": "Ihre persönliche E-Mail",
    "updatedSuccessfully": "erfolgreich aktualisiert",
    "failedToUpdate": "Aktualisierung fehlgeschlagen",
    "noChangesMade": "Keine Änderungen vorgenommen",
    "isRequired": "ist erforderlich",
    "notifications": "Benachrichtigungen",
    "noNotifications": "Keine Benachrichtigungen",
    "allCaughtUp": "Sie sind auf dem neuesten Stand!",
    "notification": "Benachrichtigung",
    "byName": "Von {name}",
    "sent": "Gesendet",
    "read": "Gelesen",
    "justNow": "Gerade eben",
    "dayAgo": "vor {count} Tag",
    "daysAgo": "vor {count} Tagen",
    "hourAgo": "vor {count} Stunde",
    "hoursAgo": "vor {count} Stunden",
    "minuteAgo": "vor {count} Minute",
    "minutesAgo": "vor {count} Minuten",
    "markAsRead": "Als gelesen markieren",
    "markAllAsRead": "Alle als gelesen markieren",
    "notificationDetails": "Benachrichtigungsdetails",
    "failedToLoadNotifications": "Benachrichtigungen konnten nicht geladen werden",
    "noInternetConnectionNotifications": "Keine Internetverbindung für Benachrichtigungen",
    "tapToMarkRead": "Zum Als-gelesen-markieren antippen",
    "unreadNotifications": "Ungelesene Benachrichtigungen",
    "success": "Erfolg",
    "updated": "Aktualisiert",
    "privateTasks": "Private Aufgaben",
    "privateTasksDescription": "Aufgaben, die keinem Projekt zugewiesen sind",
    "messages": "Nachrichten",
    "noMessages": "Keine Nachrichten",
    "messageHasError": "Nachricht hat Fehler",
    "attentionRequired": "Aufmerksamkeit erforderlich",
    "yesterday": "Gestern",
    "messageDetails": "Nachrichtendetails",
    "subject": "Betreff",
    "message": "Nachricht",
    "preview": "Vorschau",
    "details": "Einzelheiten",
    "record": "Datensatz",
    "messageSent": "Nachricht gesendet",
    "actionRequired": "Aktion erforderlich",
    "view": "Anzeigen",
    "loadingAttachments": "Anhänge werden geladen...",
    "noAttachments": "Keine Anhänge",
    "unknownFile": "Unbekannte Datei",
    "download": "Herunterladen",
    "open": "Öffnen",
    "opening": "Wird geöffnet",
    "errorOpeningFile": "Fehler beim Öffnen der Datei",
    "image": "Bild",
    "autoRefreshOn": "Auto-Aktualisierung ein",
    "autoRefreshOff": "Auto-Aktualisierung aus",
    "refreshingMessages": "Nachrichten werden aktualisiert...",
    "composeMessage": "Nachricht verfassen",
    "replyToMessage": "Auf Nachricht antworten",
    "replyingTo": "Antworten an",
    "subjectHint": "Betreff eingeben...",
    "messageHint": "Geben Sie hier Ihre Nachricht ein...",
    "send": "Senden",
    "subjectRequired": "Betreff ist erforderlich",
    "messageRequired": "Nachricht ist erforderlich",
    "noRecipients": "Keine Empfänger",
    "recipients": "Empfänger",
    "messageSentSuccessfully": "Nachricht erfolgreich gesendet",
    "deleteMessage": "Nachricht löschen",
    "areYouSureYouWantToDeleteThisMessage": "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
    "messageDeletedSuccessfully": "Nachricht erfolgreich gelöscht",
    "uploadDocumentTitle": "Dokument hochladen",
    "documentNameLabel": "Dokumentname",
    "urlLabel": "URL",
    "addUrlButton": "URL hinzufügen",
    "documentsUploadedSuccessfully": "Dokumente erfolgreich hochgeladen",
    "changePasswordTitle": "Passwort ändern",
    "currentPassword": "Aktuelles Passwort",
    "currentPasswordHint": "Aktuelles Passwort eingeben",
    "newPassword": "Neues Passwort",
    "newPasswordHint": "Neues Passwort eingeben",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "confirmNewPasswordHint": "Neues Passwort wiederholen",
    "passwordChangedSuccess": "Passwort erfolgreich geändert",
    "invalidCurrentPassword": "Aktuelles Passwort ist falsch",
    "changePasswordFailed": "Passwort konnte nicht geändert werden. Bitte versuchen Sie es erneut.",
    "expiryWarning": "Ihr Abonnement läuft in {daysRemaining} Tagen ({expiryDate}) ab. Bitte verlängern Sie es bald.",
    "expiryUrgentWarning": "DRINGEND: Ihr Abonnement läuft in {daysRemaining} Tagen ({expiryDate}) ab. Bitte verlängern Sie es sofort!",
    "subscriptionExpiredTitle": "Abonnement abgelaufen",
    "subscriptionExpiredMessage": "Ihr Abonnement ist abgelaufen. Bitte verlängern Sie es, um die App weiterhin nutzen zu können.",
    "subscriptionExpiredButton": "Jetzt verlängern",
    "subscriptionExpiredContactSupport": "Support kontaktieren",
    "subscriptionExpiredGoBackToLogin": "Zurück zum Login",
    "thisWeek": "Diese Woche",
    "listView": "Listenansicht",
    "tableView": "Tabellenansicht",
    "previousWeek": "Vorherige Woche",
    "nextWeek": "Nächste Woche",
    "thisMonth": "Dieser Monat",
    "previousMonth": "Vorheriger Monat",
    "nextMonth": "Nächster Monat",
    "weekView": "Woche",
    "monthView": "Monat",
    "projectTask": "Projekt / Aufgabe",
    "mon": "Mo",
    "tue": "Di",
    "wed": "Mi",
    "thu": "Do",
    "fri": "Fr",
    "sat": "Sa",
    "sun": "So"
  },
  "hi": {
    "language": "हिन्दी",
    "getStarted": "शुरू करें",
    "hello": "नमस्ते {name}",
    "onboardingPageOneTitle": "क्रू कोर में आपका स्वागत है",
    "onboardingPageTwoTitle": "आपकी यात्रा यहाँ से शुरू होती है",
    "onboardingPageThreeTitle": "आइए शुरू करें!",
    "onboardingBottomSheetTitle": "अपनी उपस्थिति पुष्टि करने का आसान तरीका",
    "onboardingBottomSheetSubtitle": "यह एक लंबे समय से स्थापित तथ्य है कि एक पाठक\nपठनीय सामग्री से विचलित हो जाएगा।",
    "next": "अगला",
    "needHelp": "सहायता चाहिए",
    "welcomeBack": "वापसी पर स्वागत है!",
    "to": "को",
    "loginPageSubtitle": "नमस्ते, जारी रखने के लिए लॉगिन करें",
    "email": "ई-मेल",
    "emailHint": "अपना ईमेल दर्ज करें",
    "password": "पासवर्ड",
    "passwordHint": "अपना पासवर्ड दर्ज करें",
    "forgotPassword": "पासवर्ड भूल गए?",
    "doNotHaveAnAccount": "खाता नहीं है? ",
    "haveAnAccount": "पहले से खाता मौजूद है? ",
    "register": "पंजीकरण करें",
    "orContinueWith": "या जारी रखें",
    "login": "लॉग इन",
    "firstName": "पहला नाम",
    "firstNameHint": "पहला नाम दर्ज करें",
    "lastName": "अंतिम नाम",
    "lastNameHint": "अंतिम नाम दर्ज करें",
    "confirmPassword": "पासवर्ड की पुष्टि करें",
    "confirmPasswordHint": "अपना पासवर्ड फिर से दर्ज करें",
    "iAgreeToThe": "मैं इससे सहमत हूं ",
    "termsAndConditions": "नियम और शर्तें",
    "requiredField": "यह फ़ील्ड आवश्यक है।",
    "invalidEmail": "कृपया एक वैध ईमेल पता दर्ज करें।",
    "passwordTooShort": "पासवर्ड कम से कम 6 वर्णों का होना चाहिए।",
    "passwordsDoNotMatch": "पासवर्ड मेल नहीं खाते",
    "acceptTermsMessage": "जारी रखने के लिए आपको नियम और शर्तें स्वीकार करनी होंगी।",
    "forgot_password": "पासवर्ड भूल गए",
    "provide_mail": "बस हमें अपना मेल प्रदान करें",
    "doNot_worry": "चिंता न करें",
    "send_email": "ईमेल भेजें",
    "termsAndConditionsText": "हमारे एप्लिकेशन में आपका स्वागत है। इस ऐप तक पहुंचने या उसका उपयोग करने से, आप निम्नलिखित नियमों और शर्तों से बंधे होते हैं।\n\n1. नियमों की स्वीकृति\nएक खाता बनाकर या हमारी सेवाओं का उपयोग करके, आप इन नियमों और हमारी गोपनीयता नीति से सहमत होते हैं।\n\n2. उपयोगकर्ता जिम्मेदारियां\n- ऐप का उपयोग करने के लिए आपकी आयु कम से कम 13 वर्ष होनी चाहिए।\n- आप अपने खाते की गोपनीयता बनाए रखने के लिए जिम्मेदार हैं।\n- आपको सटीक, वर्तमान और पूर्ण जानकारी प्रदान करनी होगी।\n\n3. उपयोग प्रतिबंध\nआप सहमत हैं कि आप नहीं करेंगे:\n- किसी अवैध या अनधिकृत उद्देश्य के लिए ऐप का उपयोग करें।\n- ऐप के संचालन में हस्तक्षेप करें।\n- अनधिकृत पहुंच प्राप्त करने का प्रयास करें।\n\n4. बौद्धिक संपदा\nसभी सामग्री और डेटा ऐप मालिक की बौद्धिक संपदा हैं और बिना अनुमति के उपयोग नहीं किए जा सकते।\n\n5. समाप्ति\nयदि आप इन नियमों का उल्लंघन करते हैं, तो हम बिना किसी सूचना के आपकी पहुंच को निलंबित या समाप्त कर सकते हैं।\n\n6. अस्वीकरण\nयह ऐप बिना किसी वारंटी के \"जैसा है\" प्रदान किया जाता है।\n\n7. नियमों में परिवर्तन\nहम किसी भी समय इन नियमों को अपडेट कर सकते हैं। निरंतर उपयोग का मतलब है कि आप परिवर्तनों को स्वीकार करते हैं।\n\n8. हमसे संपर्क करें\nयदि आपके प्रश्न हैं, तो support@example.com पर संपर्क करें।",
    "noInternetMessage": "कोई इंटरनेट कनेक्शन नहीं। कृपया अपना कनेक्शन जांचें।",
    "unknownError": "एक अज्ञात त्रुटि हुई। कृपया बाद में पुन: प्रयास करें।",
    "invalidEmailOrPassword": "अमान्य ईमेल या पासवर्ड",
    "wrongPassword": "अमान्य पासवर्ड। कृपया अपना पासवर्ड जांचें।",
    "companyNotFound": "कंपनी नहीं मिली। कृपया कंपनी का नाम जांचें।",
    "invalidToken": "अमान्य सत्र टोकन। कृपया पुनः लॉग इन करें।",
    "genericLoginError": "एक त्रुटि हुई। कृपया बाद में पुन: प्रयास करें।",
    "congratulations": "बधाई हो",
    "yourAccountIsReadyToUse": "आपका खाता उपयोग के लिए तैयार है!",
    "resetEmailSent": "रीसेट ईमेल सफलतापूर्वक भेजा गया।",
    "enableBiometrics": "बायोमेट्रिक लॉगिन सक्षम करें?",
    "enableBiometricsDescription": "क्या आप अगली बार अपनी फिंगरप्रिंट या चेहरे का उपयोग करके तेजी से लॉगिन करना चाहेंगे?",
    "loginWithBiometrics": "बायोमेट्रिक्स के साथ लॉगिन करें",
    "yes": "हाँ",
    "no": "नहीं",
    "biometricsNotFound": "बायोमेट्रिक्स नहीं मिले! कृपया फिर से साइन इन करें",
    "resetPasswordTitle": "पासवर्ड रीसेट करें?",
    "resetPasswordWarning": "यदि आप अपना पासवर्ड रीसेट करते हैं, तो आपका बायोमेट्रिक लॉगिन अक्षम हो जाएगा। आपको फिर से साइन इन करना होगा और इसे पुन: सक्षम करना होगा।",
    "cancel": "रद्द करें",
    "continueText": "जारी रखें",
    "googleSignInFailed": "Google साइन-इन रद्द कर दिया गया या विफल रहा",
    "myWorkSummary": "मेरा कार्य सारांश",
    "myWorkSummarySubtitle": "आज का कार्य और उपस्थिति गतिविधि",
    "todaysAttendance": "आज की उपस्थिति",
    "totalWorkingHours": "कुल कार्य घंटे",
    "today": "आज",
    "breaksToday": "आज के विराम",
    "clockIn": "क्लॉक इन",
    "backToWork": "काम पर वापस",
    "takeABreak": "विराम लें",
    "clockOut": "क्लॉक आउट",
    "hoursLabel": "{hours}:{minutes} घंटे",
    "paidPeriod": "भुगतान अवधि {start} - {end}",
    "period": "अवधि {start} - {end}",
    "clockInAreaTitle": "आप क्लॉक-इन क्षेत्र में हैं!",
    "clockInAreaDescription": "अब आप इस क्षेत्र में क्लॉक इन दबा सकते हैं",
    "notInClockInAreaTitle": "आप क्लॉक-इन क्षेत्र से बाहर हैं!",
    "notInClockOutAreaTitle": "आप क्लॉक-आउट क्षेत्र से बाहर हैं!",
    "notInClockInAreaDescription": "आप इस क्षेत्र से क्लॉक नहीं कर सकते",
    "myProfileSection": "मेरी प्रोफ़ाइल",
    "scheduleSection": "अनुसूची",
    "clockInAreaLabel": "क्लॉक इन/आउट क्षेत्र",
    "fetchingLocation": "स्थान प्राप्त किया जा रहा है…",
    "error": "त्रुटि",
    "yourActivity": "आपकी गतिविधि",
    "activity": "गतिविधि",
    "onTime": "समय पर",
    "viewAll": "सभी देखें",
    "confirmClockOutTitle": "क्लॉकआउट की पुष्टि करें",
    "confirmClockOutMessage": "एक बार जब आप क्लॉक आउट कर देते हैं, तो आप इस समय को संपादित नहीं कर पाएंगे। आगे बढ़ने से पहले कृपया अपने घंटों को दोबारा जांचें।",
    "noLetMeCheck": "नहीं, मुझे जांच करने दें",
    "thisPayPeriod": "भुगतान अवधि",
    "locationUnavailable": "स्थान उपलब्ध नहीं",
    "locationUnavailableMessage": "आपका स्थान उपलब्ध नहीं है। कृपया अपने डिवाइस की स्थान सेटिंग्स जांचें और पुन: प्रयास करें।",
    "noInternetActionSaved": "कोई इंटरनेट कनेक्शन नहीं। आपका क्लॉक-इन/आउट स्थानीय रूप से सहेज लिया गया है और एक बार ऑनलाइन होने पर सिंक हो जाएगा।",
    "manager": "प्रबंधक",
    "client": "ग्राहक",
    "tasks": "कार्य",
    "projects": "परियोजनाएं",
    "projectsSubtitle": "वे परियोजनाएं जो आपको सौंपी गई हैं",
    "tasksSubtitle": "आपको सौंपे गए कार्य",
    "home": "होम",
    "attendance": "उपस्थिति",
    "more": "अधिक",
    "pleaseWaitOneMinute": "कृपया कार्यों के बीच कम से कम 1 मिनट प्रतीक्षा करें।",
    "leaveSummary": "अवकाश सारांश",
    "available": "उपलब्ध",
    "leaveUsed": "अवकाश उपयोग",
    "review": "समीक्षा",
    "approved": "स्वीकृत",
    "rejected": "अस्वीकृत",
    "leaveSubmitted": "अवकाश प्रस्तुत",
    "leaveInformation": "अवकाश जानकारी",
    "expensesSubmitted": "व्यय प्रस्तुत",
    "expensesInformation": "व्यय जानकारी",
    "approvalSubmitted": "अनुमोदन प्रस्तुत",
    "approvalInformation": "अनुमोदन जानकारी",
    "leaveDate": "अवकाश तिथि",
    "approvedAt": "पर स्वीकृत",
    "rejectedAt": "पर अस्वीकृत",
    "expenseSummary": "व्यय सारांश",
    "claimYourExpensesHere": "अपने व्यय यहाँ दावा करें।",
    "totalLeave": "कुल अवकाश",
    "totalExpense": "कुल व्यय",
    "total": "कुल",
    "type": "प्रकार",
    "allApprovals": "सभी अनुमोदन",
    "totalApprovals": "कुल अनुमोदन",
    "noLeaveSubmitted": "कोई अवकाश प्रस्तुत नहीं!",
    "noLeaveApproved": "कोई अवकाश स्वीकृत नहीं!",
    "noLeaveRejected": "कोई अवकाश अस्वीकृत नहीं!",
    "noLeaveSubmittedSubtitle": "ताजी हवा लेने के लिए तैयार? \"अवकाश प्रस्तुत करें\" पर क्लिक करें और वह योग्य विराम लें!",
    "noExpenseSubmitted": "कोई व्यय प्रस्तुत नहीं!",
    "noExpenseApproved": "कोई व्यय स्वीकृत नहीं!",
    "noExpenseRejected": "कोई व्यय अस्वीकृत नहीं!",
    "noExpenseSubtitle": "ऐसा लगता है कि आपके यहाँ कोई व्यय नहीं है। चिंता न करें, नए व्यय डेटा आने पर यह स्थान अपडेट हो जाएगा।",
    "noApprovalSubmitted": "कोई अनुमोदन प्रस्तुत नहीं!",
    "noApprovalApproved": "कोई अनुमोदन स्वीकृत नहीं!",
    "noApprovalRejected": "कोई अनुमोदन अस्वीकृत नहीं!",
    "noApprovalSubtitle": "ऐसा लगता है कि आपके यहाँ कोई अनुमोदन नहीं है। चिंता न करें, नए अनुमोदन डेटा आने पर यह स्थान अपडेट हो जाएगा।",
    "pleaseSelectLeaveCategory": "कृपया एक अवकाश श्रेणी चुनें",
    "pleaseSelectLeaveDuration": "कृपया अवकाश अवधि चुनें",
    "pleaseSelectTaskDelegation": "कृपया कार्य प्रत्यायोजन चुनें",
    "submitLeave": "अवकाश प्रस्तुत करें",
    "submitLeaveMessage": "अपनी अवकाश विवरण की दोबारा जांच करें यह सुनिश्चित करने के लिए कि सब कुछ सही है। क्या आप आगे बढ़ना चाहते हैं?",
    "submitMessage": "यह सुनिश्चित करने के लिए कि सब कुछ सही है, अपना विवरण दोबारा जांचें। क्या आप आगे बढ़ना चाहते हैं?",
    "submitText": "हाँ, प्रस्तुत करें",
    "fillLeaveInformation": "अवकाश जानकारी भरें",
    "informationAboutLeaveDetails": "अवकाश विवरण के बारे में जानकारी",
    "leaveCategory": "अवकाश श्रेणी",
    "selectLeaveCategory": "अवकाश श्रेणी चुनें",
    "leaveDuration": "अवकाश अवधि",
    "selectDuration": "अवधि चुनें",
    "taskDelegation": "कार्य प्रत्यायोजन",
    "selectTaskDelegation": "कार्य प्रत्यायोजन चुनें",
    "emergencyContactDuringLeavePeriod": "अवकाश अवधि के दौरान आपातकालीन संपर्क",
    "pleaseEnterContactNumber": "कृपया संपर्क नंबर दर्ज करें",
    "numberTooShort": "नंबर बहुत छोटा है",
    "leaveDescription": "अवकाश विवरण",
    "enterLeaveDescription": "अवकाश विवरण दर्ज करें",
    "pleaseEnterDescription": "कृपया विवरण दर्ज करें",
    "submitNow": "अभी प्रस्तुत करें",
    "selectCategory": "श्रेणी चुनें",
    "leaveRequest": "अवकाश अनुरोध",
    "expenseRequest": "व्यय अनुरोध",
    "approvalRequest": "अनुमोदन अनुरोध",
    "leavesApproved": "अवकाश स्वीकृत",
    "leavesRejected": "अवकाश अस्वीकृत",
    "expensesApproved": "व्यय स्वीकृत",
    "expensesRejected": "व्यय अस्वीकृत",
    "approvalsApproved": "अनुमोदन स्वीकृत",
    "approvalsRejected": "अनुमोदन अस्वीकृत",
    "submitExpense": "व्यय प्रस्तुत करें",
    "fillClaimInformation": "दावा जानकारी भरें",
    "informationAboutClaimDetails": "दावा विवरण के बारे में जानकारी",
    "expenseCategory": "व्यय श्रेणी",
    "selectExpenseCategory": "व्यय श्रेणी चुनें",
    "paidBy": "द्वारा भुगतान",
    "selectEmployeeOrCompany": "कर्मचारी या कंपनी चुनें",
    "expenseDate": "व्यय तिथि",
    "enterTransactionDate": "लेनदेन तिथि दर्ज करें",
    "expenseAmount": "व्यय राशि",
    "expenseDescription": "व्यय विवरण",
    "enterExpenseDescription": "व्यय विवरण दर्ज करें",
    "uploadClaimDocument": "दावा दस्तावेज़ अपलोड करें",
    "enterPeriod": "अवधि दर्ज करें",
    "submitApproval": "अनुमोदन प्रस्तुत करें",
    "fillApprovalInformation": "अनुमोदन जानकारी भरें",
    "informationAboutApprovalDetails": "अनुमोदन विवरण के बारे में जानकारी",
    "approvalCategory": "अनुमोदन श्रेणी",
    "selectApprovalCategory": "अनुमोदन श्रेणी चुनें",
    "requestOwner": "अनुरोध स्वामी",
    "location": "स्थान",
    "pleaseEnterLocation": "कृपया स्थान दर्ज करें",
    "date": "तिथि",
    "enterDate": "तिथि दर्ज करें",
    "periodd": "अवधि",
    "reference": "संदर्भ",
    "pleaseEnterReference": "कृपया संदर्भ दर्ज करें",
    "contact": "संपर्क",
    "pleaseEnterContact": "कृपया संपर्क दर्ज करें",
    "uploadFile": "फ़ाइल अपलोड करें",
    "approvalDescription": "अनुमोदन विवरण",
    "enterApprovalDescription": "अनुमोदन विवरण दर्ज करें",
    "quantity": "मात्रा",
    "enterQuantity": "मात्रा दर्ज करें",
    "pleaseEnterQuantity": "कृपया एक वैध मात्रा दर्ज करें",
    "quantityMustBePositiveNumber": "मात्रा एक धनात्मक संख्या होनी चाहिए",
    "product": "उत्पाद",
    "addProduct": "उत्पाद जोड़ें",
    "productName": "उत्पाद नाम",
    "description": "विवरण",
    "close": "बंद करें",
    "add": "जोड़ें",
    "requests": "अनुरोध",
    "title": "शीर्षक",
    "pleaseEnterTitle": "कृपया एक शीर्षक दर्ज करें",
    "errorLoadingCategories": "श्रेणियाँ लोड करने में त्रुटि।",
    "noCategoriesAvailable": "कोई श्रेणी उपलब्ध नहीं।",
    "amount": "राशि",
    "enterAmount": "राशि दर्ज करें",
    "errorLoadingContacts": "संपर्क लोड करने में त्रुटि",
    "name": "नाम",
    "enterName": "नाम दर्ज करें",
    "pleaseEnterName": "कृपया एक नाम दर्ज करें।",
    "enterValidAmount": "कृपया एक वैध राशि दर्ज करें।",
    "account": "खाता",
    "selectAccount": "खाता चुनें",
    "selectExpenseAccount": "व्यय खाता चुनें",
    "vendor": "विक्रेता",
    "selectVendor": "विक्रेता चुनें",
    "selectExpenseVendor": "व्यय विक्रेता चुनें",
    "saleOrder": "बिक्री आदेश",
    "selectSaleOrder": "बिक्री आदेश चुनें",
    "selectExpenseSaleOrder": "व्यय बिक्री आदेश चुनें",
    "currency": "मुद्रा",
    "selectCurrency": "मुद्रा चुनें",
    "selectExpenseCurrency": "व्यय मुद्रा चुनें",
    "customerToReinvoice": "पुनः चालान करने के लिए ग्राहक",
    "selectCustomerToReinvoice": "पुनः चालान करने के लिए ग्राहक चुनें",
    "pleaseEnterStartDate": "कृपया एक प्रारंभ तिथि दर्ज करें।",
    "pleaseEnterEndDate": "कृपया एक समाप्ति तिथि दर्ज करें।",
    "startDate": "प्रारंभ तिथि",
    "endDate": "समाप्ति तिथि",
    "pleaseEnterStartTime": "कृपया एक प्रारंभ समय दर्ज करें।",
    "pleaseEnterEndTime": "कृपया एक समाप्ति समय दर्ज करें।",
    "startTime": "प्रारंभ समय",
    "endTime": "समाप्ति समय",
    "pleaseSelectDayPart": "कृपया एक दिन का भाग चुनें।",
    "hourBasedLeave": "घंटा आधारित अवकाश",
    "halfDayLeave": "आधे दिन का अवकाश",
    "selectStartTime": "प्रारंभ समय चुनें",
    "selectEndTime": "समाप्ति समय चुनें",
    "selectDayPart": "दिन का भाग चुनें",
    "dayPart": "दिन का भाग",
    "categoryLeaveDaysExceeded": "अवकाश दिनों की कुल संख्या इस श्रेणी के लिए अनुमत सीमा से अधिक है।",
    "allowedDays": "अनुमत दिन:",
    "allowedHours": "अनुमत घंटे:",
    "endTimeMustBeAfterStartTime": "समाप्ति समय प्रारंभ समय के बाद होना चाहिए",
    "categoryLeaveBalanceExceeded": "अनुरोधित अवकाश आपके शेष बैलेंस से अधिक है",
    "hr": "एचआर",
    "employees": "कर्मचारी",
    "viewAndEditYourEmployeesData": "अपने कर्मचारियों के डेटा को देखें और संपादित करें",
    "employeesInformation": "कर्मचारियों की जानकारी",
    "noName": "कोई नाम नहीं",
    "noEmail": "कोई ईमेल नहीं",
    "noPhone": "कोई फोन नहीं",
    "noType": "कोई प्रकार नहीं",
    "changesSavedSuccessfully": "परिवर्तन सफलतापूर्वक सहेजे गए!",
    "editModeEnabled": "संपादन मोड सक्षम",
    "confirmDelete": "हटाने की पुष्टि करें",
    "areYouSureYouWantToDeleteThisEmployee": "क्या आप वाकई इस कर्मचारी को हटाना चाहते हैं?",
    "thisActionCannotBeUndone": "इस कार्य को पूर्ववत नहीं किया जा सकता।",
    "delete": "हटाएं",
    "employeeDeletedSuccessfully": "कर्मचारी सफलतापूर्वक हटा दिया गया",
    "addLocation": "स्थान जोड़ें",
    "locationName": "स्थान का नाम",
    "address": "पता",
    "locationAddedSuccessfully": "स्थान सफलतापूर्वक जोड़ा गया",
    "employeeDetails": "कर्मचारी विवरण",
    "employeeInformation": "कर्मचारी जानकारी",
    "fullName": "पूरा नाम",
    "workEmail": "कार्य ईमेल",
    "workPhone": "कार्य फोन",
    "employeeType": "कर्मचारी प्रकार",
    "departmentID": "विभाग आईडी",
    "companyInformation": "कंपनी जानकारी",
    "company": "कंपनी",
    "notSpecified": "निर्दिष्ट नहीं",
    "categories": "श्रेणियाँ",
    "none": "कोई नहीं",
    "assignedLocations": "निर्दिष्ट स्थान",
    "noLocationsAssigned": "कोई स्थान निर्दिष्ट नहीं",
    "saveChanges": "परिवर्तन सहेजें",
    "employeeAlreadyExists": "कर्मचारी पहले से मौजूद है",
    "createNewEmployee": "नया कर्मचारी बनाएं",
    "employeeName": "कर्मचारी का नाम",
    "enterFullName": "पूरा नाम दर्ज करें",
    "pleaseEnterEmployeeName": "कृपया कर्मचारी का नाम दर्ज करें",
    "enterWorkEmail": "कार्य ईमेल दर्ज करें",
    "pleaseEnterEmailAddress": "कृपया ईमेल पता दर्ज करें",
    "pleaseEnterAValidEmail": "कृपया एक वैध ईमेल दर्ज करें",
    "createEmployee": "कर्मचारी बनाएं",
    "byCreatingThisProfileYouAgreeToOurTermsOfService": "इस प्रोफाइल को बनाकर, आप हमारी सेवा की शर्तों से सहमत होते हैं",
    "employeeCreatedSuccessfully": "कर्मचारी सफलतापूर्वक बनाया गया!",
    "hasBeenAddedToYourTeam": "आपकी टीम में जोड़ दिया गया है",
    "backToEmployees": "कर्मचारियों पर वापस",
    "pleaseEnter": "कृपया दर्ज करें",
    "addNewTeamMember": "नया टीम सदस्य जोड़ें",
    "fillInTheDetailsToCreateANewEmployeeProfile": "एक नई कर्मचारी प्रोफाइल बनाने के लिए विवरण भरें",
    "deadline": "समय सीमा",
    "progress": "प्रगति",
    "status": "स्थिति",
    "assignees": "सौंपे गए",
    "timesheets": "टाइमशीट",
    "taskId": "कार्य आईडी",
    "project": "परियोजना",
    "task": "कार्य",
    "selectTask": "कार्य चुनें",
    "allProjects": "सभी परियोजनाएँ",
    "allTasks": "सभी कार्य",
    "addTimesheet": "टाइमशीट जोड़ें",
    "quickAdd": "त्वरित जोड़",
    "loading": "लोड हो रहा है...",
    "timesheetAddedSuccessfully": "टाइमशीट सफलतापूर्वक जोड़ी गई",
    "noTimesheetRecordsYet": "अभी तक कोई टाइमशीट रिकॉर्ड नहीं",
    "enterDescription": "विवरण दर्ज करें",
    "timesheetDeletedSuccessfully": "टाइमशीट सफलतापूर्वक हटाई गई",
    "edit": "संपादित करें",
    "editTimesheet": "टाइमशीट संपादित करें",
    "currentSession": "वर्तमान सत्र",
    "locationDisabled": "स्थान अक्षम",
    "enableLocationMessage": "स्थान-आधारित क्लॉक-इन/आउट का उपयोग करने के लिए, कृपया अपनी डिवाइस सेटिंग्स में स्थान सेवाएँ सक्षम करें।",
    "settings": "सेटिंग्स",
    "microphonePermissionNotGranted": "माइक्रोफोन अनुमति प्रदान नहीं की गई",
    "microphoneAccessNeeded": "माइक्रोफोन एक्सेस आवश्यक",
    "thisAppNeedsMicrophoneAccessToRecordVoiceNotesForYourTimesheets": "इस ऐप को आपकी टाइमशीट के लिए वॉयस नोट्स रिकॉर्ड करने के लिए माइक्रोफोन एक्सेस की आवश्यकता है।",
    "deny": "अस्वीकार",
    "allow": "अनुमति दें",
    "microphonePermissionIsRequiredToRecordAudio": "ऑडियो रिकॉर्ड करने के लिए माइक्रोफोन अनुमति आवश्यक है",
    "failedToPlayRecording": "रिकॉर्डिंग चलाने में विफल",
    "voiceNote": "वॉयस नोट",
    "recording": "रिकॉर्डिंग",
    "duration": "अवधि",
    "stopRecording": "रिकॉर्डिंग रोकें",
    "recordNow": "अभी रिकॉर्ड करें",
    "addExpense": "व्यय जोड़ें",
    "submitExpenseReport": "व्यय रिपोर्ट प्रस्तुत करें",
    "reportInformation": "रिपोर्ट जानकारी",
    "informationAboutReportDetails": "रिपोर्ट विवरण के बारे में जानकारी",
    "reportName": "रिपोर्ट नाम",
    "enterReportName": "रिपोर्ट नाम दर्ज करें",
    "pleaseEnterReportName": "कृपया रिपोर्ट नाम दर्ज करें",
    "expenses": "व्यय",
    "submitReport": "रिपोर्ट प्रस्तुत करें",
    "expenseReport": "व्यय रिपोर्ट",
    "savedExpenses": "सहेजे गए व्यय",
    "expensesInProgress": "प्रगति में व्यय",
    "saveExpense": "व्यय सहेजें",
    "expenseSaved": "व्यय सहेजा गया",
    "selectProject": "परियोजना चुनें",
    "submitForReview": "समीक्षा के लिए प्रस्तुत करें",
    "submit": "प्रस्तुत करें",
    "save": "सहेजें",
    "submitToReview": "समीक्षा के लिए प्रस्तुत करें",
    "pleaseFillAllRequiredFields": "कृपया सभी आवश्यक फ़ील्ड भरें",
    "reportSaved": "रिपोर्ट सहेजी गई",
    "reportSubmitted": "रिपोर्ट प्रस्तुत की गई",
    "addAtLeastOneExpense": "कम से कम एक व्यय जोड़ें",
    "fixExpenseErrors": "व्यय त्रुटियाँ ठीक करें",
    "fixExpenseErrorsBeforeSubmit": "प्रस्तुत करने से पहले व्यय त्रुटियाँ ठीक करें",
    "submissionFailed": "प्रस्तुतीकरण विफल",
    "audioPlayback": "ऑडियो प्लेबैक",
    "failedToLoadAudio": "ऑडियो लोड करने में विफल",
    "failedToPlayAudio": "ऑडियो चलाने में विफल",
    "failedToStopAudio": "ऑडियो रोकने में विफल",
    "failedToSeekAudio": "ऑडियो सीक करने में विफल",
    "loadingAudio": "ऑडियो लोड हो रहा है...",
    "retry": "पुनः प्रयास करें",
    "reportDeleted": "रिपोर्ट सफलतापूर्वक हटा दी गई",
    "draft": "ड्राफ्ट",
    "reportUpdated": "रिपोर्ट सफलतापूर्वक अपडेट की गई",
    "rememberMe": "मुझे याद रखें",
    "loggingInTo": "में लॉग इन हो रहा है",
    "yourLastOrganization": "आपका अंतिम संगठन",
    "clockingOutFrom": "से क्लॉक आउट हो रहा है",
    "clockingOut": "क्लॉक आउट हो रहा है",
    "clockingInFrom": "से क्लॉक इन हो रहा है",
    "clockingIn": "क्लॉक इन हो रहा है",
    "youCanPressClockIn": "आप क्लॉक इन दबा सकते हैं",
    "youCanPressClockOut": "आप क्लॉक आउट दबा सकते हैं",
    "thereWasNoChangesApplied": "कोई परिवर्तन लागू नहीं किए गए",
    "fromTo": "से - तक",
    "time": "समय",
    "by": "द्वारा",
    "requestDetails": "अनुरोध विवरण",
    "products": "उत्पाद",
    "approval": "अनुमोदन",
    "recordOn": "पर रिकॉर्ड",
    "category": "श्रेणी",
    "lastUpdatedOn": "अंतिम अपडेट",
    "dateSet": "तिथि निर्धारित",
    "contactName": "संपर्क नाम",
    "contactEmail": "संपर्क ईमेल",
    "attachments": "अटैचमेंट",
    "couldNotOpenLink": "लिंक नहीं खोल सका",
    "approversInformation": "अनुमोदकों की जानकारी",
    "unknown": "अज्ञात",
    "errorLoadingProducts": "उत्पाद लोड करने में त्रुटि",
    "noProductsAvailable": "कोई उत्पाद उपलब्ध नहीं",
    "noExpensesInDraft": "ड्राफ्ट में कोई व्यय नहीं",
    "expenseDetails": "व्यय विवरण",
    "nameUnset": "नाम सेट नहीं",
    "totalAmount": "कुल राशि",
    "employee": "कर्मचारी",
    "companyCurrency": "कंपनी मुद्रा",
    "currencyRate": "मुद्रा दर",
    "approvedBy": "द्वारा स्वीकृत",
    "approvedOn": "पर स्वीकृत",
    "taxes": "कर",
    "areYouSureYouWantToDeleteThisExpense": "क्या आप वाकई इस व्यय को हटाना चाहते हैं?",
    "areYouSureYouWantToDeleteThisReport": "क्या आप वाकई इस रिपोर्ट को हटाना चाहते हैं?",
    "currencyNotFound": "मुद्रा नहीं मिली",
    "notFound": "नहीं मिला",
    "errorSelectingCurrency": "मुद्रा चयन में त्रुटि",
    "unnamedCurrency": "अनाम मुद्रा",
    "noCurrencySelected": "कोई मुद्रा चयनित नहीं",
    "errorLoadingCurrencies": "मुद्राएँ लोड करने में त्रुटि",
    "noCurrenciesAvailable": "कोई मुद्रा उपलब्ध नहीं",
    "unnamedAccount": "अनाम खाता",
    "errorLoadingAccounts": "खाते लोड करने में त्रुटि",
    "noAccountsAvailable": "कोई खाता उपलब्ध नहीं",
    "categoryNotFound": "श्रेणी नहीं मिली",
    "errorSelectingCategory": "श्रेणी चयन में त्रुटि",
    "unnamedCategory": "अनाम श्रेणी",
    "editExpense": "व्यय संपादित करें",
    "editing": "संपादन",
    "update": "अपडेट",
    "errorLoadingProjects": "परियोजनाएँ लोड करने में त्रुटि",
    "addProjects": "परियोजनाएँ जोड़ें",
    "allProjectsSelected": "सभी परियोजनाएँ चयनित",
    "noProjectsAvailable": "कोई परियोजना उपलब्ध नहीं",
    "unnamedSaleOrder": "अनाम बिक्री आदेश",
    "errorLoadingSaleOrders": "बिक्री आदेश लोड करने में त्रुटि",
    "noSaleOrdersAvailable": "कोई बिक्री आदेश उपलब्ध नहीं",
    "vendorNotFound": "विक्रेता नहीं मिला",
    "errorSelectingVendor": "विक्रेता चयन में त्रुटि",
    "unnamedVendor": "अनाम विक्रेता",
    "noVendorSelected": "कोई विक्रेता चयनित नहीं",
    "errorLoadingVendors": "विक्रेता लोड करने में त्रुटि",
    "noVendorsAvailable": "कोई विक्रेता उपलब्ध नहीं",
    "areYouSureYouWantToDeleteThisLeave": "क्या आप वाकई इस अवकाश को हटाना चाहते हैं?",
    "leaveIsDeletedSuccessfully": "अवकाश सफलतापूर्वक हटा दिया गया",
    "leaveDetails": "अवकाश विवरण",
    "leaveNotFound": "अवकाश नहीं मिला",
    "dateFrom": "तिथि से",
    "dateTo": "तिथि तक",
    "numberOfDays": "दिनों की संख्या",
    "numberOfHours": "घंटों की संख्या",
    "hourFrom": "घंटा से",
    "hourTo": "घंटा तक",
    "approver": "अनुमोदक",
    "leaveUpdatedSuccessfully": "अवकाश सफलतापूर्वक अपडेट किया गया",
    "leaveSubmittedSuccessfully": "अवकाश सफलतापूर्वक प्रस्तुत किया गया",
    "updateLeave": "अवकाश अपडेट करें",
    "yesUpdate": "हाँ, अपडेट करें",
    "selectDayPartSubtitle": "दिन का भाग चुनें",
    "search": "खोजें",
    "untitledTask": "अनाम कार्य",
    "noTasksAssignedYet": "अभी तक कोई कार्य सौंपा नहीं गया",
    "updateTimeSheet": "टाइमशीट अपडेट करें",
    "addTimeSheet": "टाइमशीट जोड़ें",
    "enterTime": "समय दर्ज करें",
    "timeAddedSuccessfully": "समय सफलतापूर्वक जोड़ा गया",
    "attachment": "अटैचमेंट",
    "items": "आइटम",
    "logout": "लॉगआउट",
    "changeLanguage": "भाषा बदलें",
    "selectYourPreferredLanguage": "अपनी पसंदीदा भाषा चुनें",
    "taskStage": "कार्य चरण",
    "noStage": "कोई चरण नहीं",
    "updating": "अपडेट हो रहा है...",
    "errorLoadingStages": "चरण लोड करने में त्रुटि",
    "loadingStages": "चरण लोड हो रहे हैं...",
    "stageUpdatedTo": "चरण अपडेट किया गया",
    "failedToUpdateStage": "चरण अपडेट करने में विफल",
    "selected": "चयनित",
    "noStagesAvailable": "कोई चरण उपलब्ध नहीं",
    "current": "वर्तमान",
    "updatingStage": "चरण अपडेट हो रहा है...",
    "reasonOfRejection": "अस्वीकृति का कारण",
    "documents": "दस्तावेज़",
    "noDocuments": "कोई दस्तावेज़ नहीं मिला",
    "documentDetails": "दस्तावेज़ विवरण",
    "createDocument": "दस्तावेज़ बनाएं",
    "editDocument": "दस्तावेज़ संपादित करें",
    "deleteDocument": "दस्तावेज़ हटाएं",
    "deleteDocumentConfirmation": "क्या आप वाकई इस दस्तावेज़ को हटाना चाहते हैं?",
    "documentType": "दस्तावेज़ प्रकार",
    "issueDate": "जारी करने की तिथि",
    "expiryDate": "समाप्ति तिथि",
    "systemInformation": "सिस्टम जानकारी",
    "createdBy": "द्वारा बनाया गया",
    "createdOn": "पर बनाया गया",
    "lastUpdatedBy": "अंतिम अपडेट द्वारा",
    "notificationDays": "सूचना दिवस",
    "notificationType": "सूचना प्रकार",
    "active": "सक्रिय",
    "expired": "समाप्त",
    "expiringSoon": "जल्द ही समाप्त",
    "valid": "वैध",
    "noExpiry": "कोई समाप्ति नहीं",
    "expiredDocuments": "समाप्त दस्तावेज़",
    "expiringDocuments": "जल्द ही समाप्त",
    "failedToFetchDocuments": "दस्तावेज़ लोड करने में विफल। कृपया पुन: प्रयास करें।",
    "failedToCreateDocument": "दस्तावेज़ बनाने में विफल। कृपया पुन: प्रयास करें।",
    "failedToUpdateDocument": "दस्तावेज़ अपडेट करने में विफल। कृपया पुन: प्रयास करें।",
    "failedToDeleteDocument": "दस्तावेज़ हटाने में विफल। कृपया पुन: प्रयास करें।",
    "documentCreatedSuccessfully": "दस्तावेज़ सफलतापूर्वक बनाया गया",
    "documentUpdatedSuccessfully": "दस्तावेज़ सफलतापूर्वक अपडेट किया गया",
    "documentDeletedSuccessfully": "दस्तावेज़ सफलतापूर्वक हटाया गया",
    "noDocumentSelected": "कोई दस्तावेज़ चयनित नहीं",
    "invalidDocumentData": "अमान्य दस्तावेज़ डेटा। कृपया आवश्यक फ़ील्ड जांचें।",
    "sessionExpired": "सत्र समाप्त। कृपया फिर से लॉग इन करें।",
    "accessDenied": "पहुंच अस्वीकृत। आपके पास इस कार्य को करने की अनुमति नहीं है।",
    "networkError": "नेटवर्क त्रुटि हुई। कृपया अपना इंटरनेट कनेक्शन जांचें।",
    "pleaseEnterDocumentName": "कृपया दस्तावेज़ नाम दर्ज करें",
    "pleaseSelectDocumentType": "कृपया दस्तावेज़ प्रकार चुनें",
    "pleaseSelectEmployee": "कृपया कर्मचारी चुनें",
    "invalidDate": "अमान्य तिथि प्रारूप",
    "expiryDateBeforeIssueDate": "समाप्ति तिथि जारी करने की तिथि से पहले नहीं हो सकती",
    "documentNameRequired": "दस्तावेज़ नाम आवश्यक है",
    "documentTypeRequired": "दस्तावेज़ प्रकार आवश्यक है",
    "documentName": "दस्तावेज़ नाम",
    "selectDocumentType": "दस्तावेज़ प्रकार चुनें",
    "loadingDocumentTypes": "दस्तावेज़ प्रकार लोड हो रहे हैं...",
    "errorLoadingDocumentTypes": "दस्तावेज़ प्रकार लोड करने में त्रुटि",
    "noDocumentTypesAvailable": "कोई दस्तावेज़ प्रकार उपलब्ध नहीं",
    "documentNumber": "दस्तावेज़ नंबर",
    "overdue": "अतिदेय",
    "created": "बनाया गया",
    "payslips": "वेतन पर्ची",
    "viewYourSalarySlips": "अपनी वेतन पर्चियाँ देखें",
    "noPayslips": "कोई वेतन पर्ची उपलब्ध नहीं",
    "payslipDetails": "वेतन पर्ची विवरण",
    "noPayslipDetails": "कोई वेतन पर्ची विवरण उपलब्ध नहीं",
    "pending": "लंबित",
    "paid": "भुगतान किया गया",
    "earnings": "आय",
    "deductions": "कटौतियाँ",
    "other": "अन्य",
    "pendingPayslips": "लंबित वेतन पर्चियाँ",
    "cancelled": "रद्द",
    "unnamedPayslip": "अनाम वेतन पर्ची",
    "noNumber": "कोई नंबर नहीं",
    "basicWage": "मूल वेतन",
    "grossWage": "सकल वेतन",
    "netWage": "शुद्ध वेतन",
    "from": "से",
    "unnamedItem": "अनाम आइटम",
    "done": "पूर्ण",
    "salaryComputation": "वेतन गणना",
    "workedDays": "कार्य दिवस",
    "otherInfo": "अन्य जानकारी",
    "workedDaysDescription": "कार्य दिवस, ओवरटाइम और छुट्टियों का विस्तृत विवरण",
    "otherInfoDescription": "अतिरिक्त वेतन पर्ची जानकारी और विवरण",
    "payslipNumber": "वेतन पर्ची नंबर",
    "contract": "अनुबंध",
    "payStructure": "वेतन संरचना",
    "errorLoadingWorkedDays": "कार्य दिवस लोड करने में त्रुटि",
    "noWorkedDays": "कोई कार्य दिवस डेटा नहीं",
    "noWorkedDaysDescription": "इस वेतन पर्ची अवधि के लिए कोई कार्य दिवस जानकारी उपलब्ध नहीं",
    "workedDaysSummary": "कार्य दिवस सारांश",
    "totalDays": "कुल दिन",
    "totalHours": "कुल घंटे",
    "days": "दिन",
    "hours": "घंटे",
    "minutes": "मिनट",
    "unpaid": "अवैतनिक",
    "creditTime": "क्रेडिट समय",
    "searchProjectsHint": "परियोजना नाम या ग्राहक से खोजें...",
    "noProjectsFound": "कोई परियोजना नहीं मिली",
    "tryDifferentKeywords": "विभिन्न खोज शब्द आज़माएं",
    "searchTasksHint": "कार्य नाम से खोजें...",
    "noTasksFound": "कोई कार्य नहीं मिला",
    "showing": "दिखा रहा है",
    "clearFilter": "फ़िल्टर साफ़ करें",
    "allStages": "सभी चरण",
    "filterByStage": "चरण से फ़िल्टर करें",
    "all": "सभी",
    "noDocumentsFound": "कोई दस्तावेज़ नहीं मिला",
    "searchDocumentsHint": "दस्तावेज़ खोजें (नाम, प्रकार, विवरण)...",
    "userProfile": "उपयोगकर्ता प्रोफ़ाइल",
    "contactInformation": "संपर्क जानकारी",
    "jobInformation": "नौकरी की जानकारी",
    "timeAttendance": "समय और उपस्थिति",
    "emergencyContact": "आपातकालीन संपर्क",
    "noProfileData": "कोई प्रोफ़ाइल डेटा उपलब्ध नहीं",
    "mobile": "मोबाइल",
    "personalEmail": "व्यक्तिगत ईमेल",
    "personalPhone": "व्यक्तिगत फोन",
    "notProvided": "प्रदान नहीं किया गया",
    "department": "विभाग",
    "jobPosition": "नौकरी पद",
    "coach": "कोच",
    "workLocation": "कार्य स्थान",
    "workSchedule": "कार्य अनुसूची",
    "hourlyCost": "प्रति घंटा लागत",
    "checkedIn": "चेक इन",
    "checkedOut": "चेक आउट",
    "absent": "अनुपस्थित",
    "lastMonth": "पिछला महीना",
    "totalOvertime": "कुल ओवरटाइम",
    "lastCheckIn": "अंतिम चेक-इन",
    "lastCheckOut": "अंतिम चेक-आउट",
    "remaining": "शेष",
    "totalAllocated": "कुल आवंटित",
    "used": "उपयोग किया गया",
    "currentLeave": "वर्तमान अवकाश",
    "emergencyPhone": "आपातकालीन फोन",
    "additionalContactInformation": "अतिरिक्त संपर्क जानकारी",
    "privatePhone": "निजी फोन",
    "privateEmail": "निजी ईमेल",
    "noEmergencyContactSet": "कोई आपातकालीन संपर्क सेट नहीं",
    "pleaseUpdateEmergencyContact": "कृपया अपनी आपातकालीन संपर्क जानकारी अपडेट करें",
    "addEmergencyContact": "आपातकालीन संपर्क जोड़ें",
    "editEmergencyContacts": "आपातकालीन संपर्क संपादित करें",
    "emergencyContactName": "आपातकालीन संपर्क नाम",
    "enterPhoneNumber": "फोन नंबर दर्ज करें",
    "yourPersonalPhoneNumber": "आपका निजी फोन नंबर",
    "yourPersonalEmail": "आपका निजी ईमेल",
    "updatedSuccessfully": "सफलतापूर्वक अपडेट किया गया",
    "failedToUpdate": "अपडेट करने में विफल",
    "noChangesMade": "कोई परिवर्तन नहीं किए गए",
    "isRequired": "आवश्यक है",
    "notifications": "सूचनाएं",
    "noNotifications": "कोई सूचना नहीं",
    "allCaughtUp": "आप पूरी तरह से अपडेट हैं!",
    "notification": "सूचना",
    "byName": "{name} द्वारा",
    "sent": "भेजा गया",
    "read": "पढ़ा गया",
    "justNow": "अभी-अभी",
    "dayAgo": "{count} दिन पहले",
    "daysAgo": "{count} दिन पहले",
    "hourAgo": "{count} घंटे पहले",
    "hoursAgo": "{count} घंटे पहले",
    "minuteAgo": "{count} मिनट पहले",
    "minutesAgo": "{count} मिनट पहले",
    "markAsRead": "पढ़ा हुआ चिह्नित करें",
    "markAllAsRead": "सभी को पढ़ा हुआ चिह्नित करें",
    "notificationDetails": "सूचना विवरण",
    "failedToLoadNotifications": "सूचनाएं लोड करने में विफल",
    "noInternetConnectionNotifications": "सूचनाओं के लिए कोई इंटरनेट कनेक्शन नहीं",
    "tapToMarkRead": "पढ़ा हुआ चिह्नित करने के लिए टैप करें",
    "unreadNotifications": "अपठित सूचनाएं",
    "success": "सफलता",
    "updated": "अपडेट किया गया",
    "privateTasks": "निजी कार्य",
    "privateTasksDescription": "ऐसे कार्य जो किसी भी परियोजना के लिए असाइन नहीं हैं",
    "messages": "संदेश",
    "noMessages": "कोई संदेश नहीं",
    "messageHasError": "संदेश में त्रुटि है",
    "attentionRequired": "ध्यान आवश्यक है",
    "yesterday": "कल",
    "messageDetails": "संदेश विवरण",
    "subject": "विषय",
    "message": "संदेश",
    "preview": "पूर्वावलोकन",
    "details": "विवरण",
    "record": "रिकॉर्ड",
    "messageSent": "संदेश भेज दिया गया",
    "actionRequired": "कार्रवाई आवश्यक",
    "view": "देखें",
    "loadingAttachments": "अटैचमेंट लोड हो रहे हैं...",
    "noAttachments": "कोई अटैचमेंट नहीं",
    "unknownFile": "अज्ञात फ़ाइल",
    "download": "डाउनलोड",
    "open": "खोलें",
    "opening": "खोल रहे हैं",
    "errorOpeningFile": "फ़ाइल खोलने में त्रुटि",
    "image": "छवि",
    "autoRefreshOn": "स्वत: रीफ्रेश चालू",
    "autoRefreshOff": "स्वत: रीफ्रेश बंद",
    "refreshingMessages": "संदेश रीफ्रेश हो रहे हैं...",
    "composeMessage": "संदेश लिखें",
    "replyToMessage": "संदेश का जवाब दें",
    "replyingTo": "इन्हें जवाब दे रहे हैं",
    "subjectHint": "विषय दर्ज करें...",
    "messageHint": "अपना संदेश यहाँ टाइप करें...",
    "send": "भेजें",
    "subjectRequired": "विषय आवश्यक है",
    "messageRequired": "संदेश आवश्यक है",
    "noRecipients": "कोई प्राप्तकर्ता नहीं",
    "recipients": "प्राप्तकर्ता",
    "messageSentSuccessfully": "संदेश सफलतापूर्वक भेजा गया",
    "deleteMessage": "संदेश हटाएं",
    "areYouSureYouWantToDeleteThisMessage": "क्या आप वाकई इस संदेश को हटाना चाहते हैं?",
    "messageDeletedSuccessfully": "संदेश सफलतापूर्वक हटाया गया",
    "uploadDocumentTitle": "दस्तावेज़ अपलोड करें",
    "documentNameLabel": "दस्तावेज़ नाम",
    "urlLabel": "URL",
    "addUrlButton": "URL जोड़ें",
    "documentsUploadedSuccessfully": "दस्तावेज़ सफलतापूर्वक अपलोड किए गए",
    "changePasswordTitle": "पासवर्ड बदलें",
    "currentPassword": "वर्तमान पासवर्ड",
    "currentPasswordHint": "वर्तमान पासवर्ड डालें",
    "newPassword": "नया पासवर्ड",
    "newPasswordHint": "नया पासवर्ड डालें",
    "confirmNewPassword": "नया पासवर्ड पुष्टि करें",
    "confirmNewPasswordHint": "नया पासवर्ड फिर से डालें",
    "passwordChangedSuccess": "पासवर्ड सफलतापूर्वक बदल गया",
    "invalidCurrentPassword": "वर्तमान पासवर्ड गलत है",
    "changePasswordFailed": "पासवर्ड नहीं बदला जा सका। कृपया पुनः प्रयास करें।",
    "expiryWarning": "आपकी सदस्यता {daysRemaining} दिनों में ({expiryDate}) समाप्त हो रही है। कृपया जल्द ही नवीनीकरण करें।",
    "expiryUrgentWarning": "तत्काल: आपकी सदस्यता {daysRemaining} दिनों में ({expiryDate}) समाप्त हो रही है। कृपया तुरंत नवीनीकरण करें!",
    "subscriptionExpiredTitle": "सदस्यता समाप्त हो गई",
    "subscriptionExpiredMessage": "आपकी सदस्यता समाप्त हो चुकी है। ऐप का उपयोग जारी रखने के लिए कृपया नवीनीकरण करें।",
    "subscriptionExpiredButton": "अभी नवीनीकरण करें",
    "subscriptionExpiredContactSupport": "सहायता से संपर्क करें",
    "subscriptionExpiredGoBackToLogin": "लॉगिन पर वापस जाएं",
    "thisWeek": "इस सप्ताह",
    "listView": "सूची दृश्य",
    "tableView": "तालिका दृश्य",
    "previousWeek": "पिछला सप्ताह",
    "nextWeek": "अगला सप्ताह",
    "thisMonth": "इस महीने",
    "previousMonth": "पिछला महीना",
    "nextMonth": "अगला महीना",
    "weekView": "सप्ताह",
    "monthView": "महीना",
    "projectTask": "प्रोजेक्ट / कार्य",
    "mon": "सोम",
    "tue": "मंगल",
    "wed": "बुध",
    "thu": "गुरु",
    "fri": "शुक्र",
    "sat": "शनि",
    "sun": "रवि"
  }
};

export default translations;
